<template>
	<div>
		<custom-message-modal v-on:notify="getCustomMessages" v-model="showPopup" v-bind:message="customMessage"></custom-message-modal>

		<sign-up-progress-bar :loading_sign_ups="loading_sign_ups"
		:sign_ups="sign_ups"
		:show_progress_bar="show_progress_bar"
		:loading_completed_course="loading_completed_course"
		:completed_course="completed_course"
		:agency="agency"
		:AgencyView="AgencyView"


		></sign-up-progress-bar>
		<div class="row mb-2">
			<div class="col-6 col-md-8 d-flex">

				<new-provider :user_role="user_role"
				:key="componentKey"
				@updateNewProviderComponent="updateNewProviderComponent"
				 v-if="user_meta_actions.includes('create_provider')">
					<template slot="text-button"  class="m-0">
						New employee
						<img class="mr-1" src="../../assets/images/icons/solid/plus_white.svg" width="11"/>
					</template>
				</new-provider>

				<div class="search input-content input-with-icon ml-3 no-margin" style="min-width: 100px; max-width:250px; width: 100%">
					<i class="fa fa-search"></i>
					<input type="text" placeholder="Search" @keyup="search_" v-model="search" id="search-employee" style="height: 32px; border:none"/>
				</div>
				<!-- <div v-if="AgencyView" class="input-content d-flex justify-content-center align-items-center ml-3 no-margin" style="min-width: 240px; max-width:400px; width: 100%">
					<label class="mr-2 green bg-gray">Agency:</label>
					<v-select :searchable="true" track-by="value" label="name" :options="selects.agencies"  v-model="agency" class="green bg-gray v-select-no-height" multiple @input="organizationChanged">
					</v-select>
				</div>	 -->

				<div class="input-content d-flex justify-content-center align-items-center ml-3 no-margin" style="min-width: 240px; max-width:400px; width: 100%">
					<label class="mr-2 green bg-gray">Program:</label>
					<v-select :searchable="true" track-by="value" label="label" :options="selects.courses" v-model="filters.course" class="green bg-gray v-select-no-height" multiple  ></v-select>
					<!-- -->
				</div>
				<div class="input-content d-flex justify-content-center align-items-center ml-3 no-margin" style="min-width: 105px; max-width: 125px;">
					<label class="mr-2 green bg-gray">Show:</label>
					<v-select :options="['10', '25', '50', '100']" v-model="per_page" class="green bg-gray" style="min-width: 65px; max-width: 65px;"></v-select>
				</div>

			</div>
			<div class="col-6 col-md-4">
				<div class="text-right">
					<!-- bulk actions button -->
					<div class="trigger-hidden-content ml-1 d-inline-block">
						<span class=" button medium-button">
							Actions <i class="fa fa-caret-down" aria-hidden="true" style="vertical-align: baseline"></i>
						</span>
						<div class="hidden-content hc-right-bottom">
							<div>
								<ul class="list-unstyled text-left">
									<!-- bulk actions if i have a course selected -->
									<template v-if="can_bulk_action_providers_in_course">


										<li v-if="user_meta_actions.includes('deactivate_activate_provider_from_program_bulk')" class="pb-2 pt-2 d-flex align-items-center cursor-pointer" @click="openBulkModal('activate_course')">
											<i class="fa fa-toggle-on fa-ninja fa-ninja-black"></i>
											<small class="ml-1">Activate in program</small>
										</li>

										<li v-if="user_meta_actions.includes('deactivate_activate_provider_from_program_bulk')"  class="pb-2 pt-2 d-flex align-items-center cursor-pointer"  @click="openBulkModal('deactivate_course')">
											<i class="fa fa-toggle-off fa-ninja fa-ninja-black"></i> <small class="ml-1">Deactivate from program</small>
										</li>
										<li v-if="user_meta_actions.includes('deactivate_activate_provider_from_program_bulk')"  class="pb-2 pt-2 d-flex align-items-center cursor-pointer"
										@click="openBulkModal('remove_course')">
											<i class="fa fa-ban fa-ninja fa-ninja-black"></i> <small class="ml-1">Remove from program</small>
										</li>
										<li  class="pb-2 pt-2 d-flex align-items-center cursor-pointer" v-if="user_meta_actions.includes('add_provider_to_a_program')" @click="openBulkModal('add_to_program')">
											<i class="fa fa-th-large fa-ninja fa-ninja-black"></i>
											<small class="ml-1">Add to program</small>
										</li>
										<li  class="pb-2 pt-2 d-flex align-items-center cursor-pointer" v-if="show_course_options && user_meta_actions.includes('download_certificate_bulk')" @click="downloadCertificates">
											<img width="18" src="../../assets/images/icons/solid/cert_2_black.svg" >
											<small class="ml-1">Download certificates</small>
										</li>
										<li  class="pb-2 pt-2 d-flex align-items-center cursor-pointer" v-if="show_course_options && user_meta_actions.includes('send_certificate_bulk')" @click="sendCertificates">
											<i class="fa fa-paper-plane fa-ninja fa-ninja-black"></i>
											<small class="ml-1">Send certificates</small>
										</li>
										<li  class="pb-2 pt-2 d-flex align-items-center cursor-pointer" v-if="show_course_options && user_meta_actions.includes('send_a_notification')" :class="{ 'input-disabled' : checked_user < 1 }" @click="openBulkModal('send_message')">
											<img width="18" src="../../assets/images/icons/solid/envelope.svg">
											<small class="ml-1">Send message</small>
										</li>
										<li class="pb-2 pt-2 d-flex align-items-center cursor-pointer" v-if="show_course_options && user_meta_actions.includes('approve_completion')" @click="openBulkModal('approve')">
											<img width="18" src="../../assets/images/icons/solid/check.svg">
											<small class="ml-1">Approve employees</small>
										</li>
										<li class="pb-2 pt-2 d-flex align-items-center cursor-pointer" v-if="show_course_options && user_meta_actions.includes('edit_provider_due_date')" @click="openBulkModal('edit_due_date')">
											<img width="18" src="../../assets/images/icons/solid/calendar.svg">
											<small class="ml-1">Edit due date</small>
										</li>
										<li class="pb-2 pt-2 d-flex align-items-center cursor-pointer" v-if="show_course_options && user_meta_actions.includes('edit_provider_due_date')" @click="openBulkModal('edit_start_date')">
											<img width="18" src="../../assets/images/icons/solid/calendar.svg">
											<small class="ml-1">Edit start date</small>
										</li>

									</template>
									<!-- bulk actions only for providers -->
									<template v-if="can_bulk_action_providers">
										<li  class="pb-2 pt-2 d-flex align-items-center cursor-pointer" v-if="user_meta_actions.includes('deactivate_activate_provider_from_the_agency')" @click="openBulkModal('activate')">
											<i class="fa fa-toggle-on fa-ninja fa-ninja-black"></i>
											<small class="ml-1">Activate</small>
										</li>

										<li  class="pb-2 pt-2 d-flex align-items-center cursor-pointer" v-if="user_meta_actions.includes('deactivate_activate_provider_from_the_agency')" @click="openBulkModal('deactivate')">
											<i class="fa fa-pause fa-ninja fa-ninja-black"></i>
											<small class="ml-1">Place on hold</small>
										</li>
										<li  class="pb-2 pt-2 d-flex align-items-center cursor-pointer" v-if="user_meta_actions.includes('deactivate_activate_provider_from_the_agency')" @click="openBulkModal('terminate')">
											<i class="fa fa-toggle-off fa-ninja fa-ninja-black"></i>
											<small class="ml-1">Terminate</small>
										</li>
										<li v-if="user_meta_actions.includes('add_provider_to_a_program_bulk')" class="pb-2 pt-2 d-flex align-items-center cursor-pointer" @click="openBulkModal('add_to_program')">
											<i class="fa fa-th-large fa-ninja fa-ninja-black"></i>
											<small class="ml-1">Add to program</small>
										</li>
									</template>
										<li  v-if="false" class="pb-2 pt-2 d-flex align-items-center cursor-pointer" @click="openBulkModal('delete_user')" :class="{ 'input-disabled' : checked_user < 1 }">
											<i class="fa fa-trash fa-ninja fa-ninja-black"></i>
											<small class="ml-1">Delete</small>
										</li>
										<!-- New Component for password reset functionalities -->
										<!-- New CSM User ACTIONS -->
										<!-- New Delete Option -->
										<!-- New send SMS Option -->
										<div v-if="user_role==='csm'">
											<password-action :user_role="user_role"
											 :checked_user="checked_user" :key="password_index" :sign_up="sign_up_status"></password-action>
										</div>
									</ul>
									</div>
								</div>
							</div>

					<!-- export providers button -->
					<button v-if="user_meta_actions.includes('export')" type="button" class="button medium-button" @click="exportProviders">
						<template v-if="loading_export">
							Exporting CSV file <i class="fa fa-spinner  fa-pulse"></i>
						</template>
						<template v-else>
							Export
						</template>
					</button>

					<!-- my saved filters button -->
					<button type="button" class="button medium-button" id="my-saved-filters-button" @click="showMySavedFilters(0, 238)">My Saved filters</button>
					<!-- show filters button -->
					<button type="button" class="button medium-button" id="show-filters-button" @click="openFilters()">

						<template v-if="show_filters">
							<i class="fa fa-times"></i>
						</template>
						<template v-else>

						<i class="fa fa-filter"></i>
						</template>

					</button>

					<!-- my saved filters popover -->

					<div class="my-saved-filters" v-if="show_my_saved_filters" :style="{ top : my_filters_top + 'px', right : my_filters_right +'px'}">
						<div class="text-right mb-2 cursor-pointer">
						<div class="h5">My saved filters
							<i class="fa fa-times" @click="show_my_saved_filters = false"></i>
						</div>


						</div>
						<template v-if="my_filters.length > 0">

							<table class="table">

								<tbody>
									<tr  v-for="my_filter in my_filters">
										<td>{{ my_filter.name }}</td>
										<td>
											<button type="button" class="button " @click="applySelectedFilter(my_filter)">Apply</button>

											<div class="trigger-hidden-content ml-1 d-inline-block">
												<span class=" button">
													<img width="15" src="../../assets/images/icons/solid/ellipsis-h_white.svg">
												</span>
												<div class="hidden-content hc-right-bottom">
													<div>
														<ul class="list-unstyled text-left">
															<li class="pb-2 pt-2 d-flex align-items-center cursor-pointer" v-if="my_filter.active == 0"
																 @click="toggleActiveFilter(my_filter)">
																<img width="12" class="mr-2" src="../../assets/images/icons/solid/check.svg">
																<span> Set as default</span>
															</li>
															<li class="pb-2 pt-2 d-flex align-items-center  cursor-pointer" @click="showModalDeleteFilter(my_filter)">
																<img width="12" class="mr-2" src="../../assets/images/icons/solid/trash.svg">
																<span> Delete</span>
															</li>
														</ul>
													</div>
												</div>
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</template>

				   		<div class="text-right">
					   		<button type="button" class="button dark-gray-content medium-button" @click="show_my_saved_filters = false">Close</button>
					   	</div>
					</div>
				</div>
			</div>
		</div>
		<div class="row mb-2">
			<div class="col text-right" v-if="filter_selected">
				<template v-if="filter_selected.name != 'Default'" class="mr-4">
					<strong><i class="fa fa-filter"></i> Filter applied:</strong>
					<span class="underline">{{ filter_applied }}</span>
				</template>
			</div>
		</div>
		<div class="row">
			<div class="col">

				<div v-if="show_select_all || this.checked_signups.length>0" class="mb-2 lightgray-content p-4">
					<!-- <span  v-if="select_all" class="bold">
						<template>

						</template>

					</span> -->
					<span class="bold">
						<template v-if="!select_all && show_select_all">
							{{this.$refs['bulk-checks'].length	}} employees on this page have been selected.
							<!-- {{ n_bulk_selected }} -->
						</template>
						<template v-if="select_all && this.checked_signups.length==0">
							All employees have been selected.
						</template>
						<template v-if="this.checked_signups.length>0 && !show_select_all">
							{{this.checked_signups.length}} employees selected
						</template>

					</span>


					<template v-if="!select_all && show_select_all">
						<button class="button ml-2" @click="selectAll">
							Select all {{total_rows}} employees
						</button>
					</template>
					<template v-else>
						<button class="button ml-2" @click="unselectAll(true)">
							Cancel selection
						</button>
					</template>
				</div>

				<div class="table-with-filters d-flex justify-content-between">
					<div class="table-responsive">

						<table class="table table-bordered loadable table-xs" :class="{ 'loading' : loading_table_providers } ">
							<thead>
								<tr>
									<th class="w-10">
										<div class="checkbox-container squared">
											<input id="check-select-all" type="checkbox" @click="showSelectAll" v-model="checkbox_bulk"/>
											<label for="check-select-all"></label>
										</div>
									</th>
									<th>Name</th>
									<th>Employee #</th>
									<th>Phone</th>
									<!-- <th>Email</th> -->
									<th>Signed up</th>
									<th>Discipline</th>
									<th>Location</th>
									<th class="w-170">Progress</th>
									<th v-if="show_course_options">Hours left</th>
									<th v-if="show_course_options">Status</th>
									<th v-if="show_course_options">Start date</th>
									<th v-if="show_course_options">Due date</th>
									<th></th>
									<th v-if="user_role ==='csm' || user_role === 'organization'" class="text-center green-content">Actions</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, index) in providers" >
									<td>
										<div class="checkbox-container squared">

											<input :id="'check-select-' + item.id + '_' + index" type="checkbox" :ref="'bulk-checks'"
													:data-id="item.id"
													:data-first-name="item.first_name"
													:data-last-name="item.last_name"
													:data-organization-provider-id="item.organization_provider_id"
													:data-organization-provider-course-id="item.organization_provider_course_id"
													:data-status-str="item.status_str"
													:data-sign_up="item.sign_up"
													@click="checkboxClicked(item)"
											/>
											<label :for="'check-select-' + item.id + '_' + index"></label>
										</div>
									</td>
									<td>
										<router-link v-if="user_role ==='csm'" :to="{ name:user_role+'.providers.detail', params : { id : item.id }, query:{agency_id: $route.params.agency_id} }" tag="a" target="_blank">

											{{ item.last_name  }} {{ item.first_name }}  	</router-link>
												<router-link v-if="user_role !='csm'" :to="{ name:user_role+'.providers.detail', params : { id : item.id } }" tag="a" target="_blank">

											{{ item.last_name || ' '}} {{ item.first_name }}  	</router-link>
									</td>
									<td>
										<router-link v-if="user_role ==='csm'" :to="{ name:user_role+'.providers.detail', params : { id : item.id }, query:{agency_id: $route.params.agency_id} }" tag="a" target="_blank">

										{{ item.employer_number}}	</router-link>
											<router-link v-if="user_role !='csm'" :to="{ name:user_role+'.providers.detail', params : { id : item.id } }" tag="a" target="_blank">

										{{ item.employer_number}}	</router-link>
									</td>
									<td>
											<router-link v-if="user_role ==='csm'" :to="{ name:user_role+'.providers.detail', params : { id : item.id }, query:{agency_id: $route.params.agency_id} }" tag="a" target="_blank">

										{{ item.phone }} 	</router-link>
												<router-link v-if="user_role !='csm'" :to="{ name:user_role+'.providers.detail', params : { id : item.id } }" tag="a" target="_blank">

											{{ item.phone }}  	</router-link>
										</td>

									<!-- <td>{{ item.email }}</td> -->
									<td>
										<span :class="{ 'circle-no' : item.sign_up == 0 }">{{ item.sign_up | yes_no }}</span>
									</td>
									<td v-if="item.disciplines.length <1"></td>
									<td v-if="item.disciplines.length ==1">{{ item.disciplines[0].name }}</td>
									<td v-if="item.disciplines.length >1">

										<div class="trigger-hidden-content d-inline-block">
											<span class=" button">
											{{ item.disciplines[0].name }}	<img width="10" src="../../assets/images/icons/solid/ellipsis-h_white.svg">
											</span>
											<div class="hidden-content hc-left"
											style="width: fit-content">
											<div>
												<ul class="list-unstyled text-left">
												<template>
													<!-- New User Login SSO -->
												<li v-for="(a,b) in item.disciplines" :key="b">
													<small class="ml-1">{{a.name}}</small>
												</li>

												</template>
												</ul>
											</div>
											</div>
										</div>







										<!-- <tr v-for="(a, b) in item.disciplines" :key="b" >
											<b-col md="3" class="py-3">
												<b v-b-tooltip.hover.right="i in item.disciplines" variant="primary">{{ item.disciplines[i] }}...</b>
											</b-col>
										</tr> -->

									</td>
									<td v-if="item.sub_location">{{ item.location }} <b>|</b> {{item.sub_location}}</td>
									<td v-else>{{ item.location }}</td>
									<td>
										<div v-if="item.no_active_programs" class="completion-bar small-bar">
											<template>
												<div v-bind:style="{ width: item.completion + '%' }"></div>
												<!-- <span >{{ item.completion | format_percent_no_dec}}%</span> -->
												<span class="not-active-text">NO ACTIVE PROGRAMS</span>
											</template>
										</div>
										<div v-else class="completion-bar small-bar">
											<!-- SINGLE PROGRAM SELECTION -->
											<template v-if="show_course_options">
												<template v-if="item.due_date_expired != 0 && item.due_date_expired != null">
													<div v-bind:style="{ width: item.completion + '%' }"></div>
													<span class="not-active-text" >EXPIRED</span>
												</template>
												<!-- THIRD OPTION NO PROGRAM -->
												<template v-else-if="no_program">
													<span class="not-active-text">No Program Assigned</span>
												</template>
												<template v-else>
													<template  v-if="item.sign_up">
														<div v-bind:style="{ width: item.completion + '%' }"></div>
														<span >{{ item.completion | format_percent_no_dec}}%</span>
													</template>
													<template v-else>
														<span class="not-active-text">USER HASN'T SIGNED UP</span>
													</template>
												</template>
											</template>
											<!-- MULTI PROGRAM SELECTION -->
											<template v-if="!show_course_options">
												<template  v-if="item.course_id != 0" ||v-if="item.course_id != null ">
													<template v-if="item.sign_up">
														<div v-bind:style="{ width: item.completion + '%' }"></div>
														<span >{{ item.completion | format_percent_no_dec}}%</span>
													</template>
													<template v-else>
														 <span class="not-active-text">
														USER HASN'T SIGNED UP</span>
													</template>
												</template>
												<template v-else>
													<span class="not-active-text">No Program Assigned</span>
												</template>
											</template>

						        		</div>
									</td>

									<td v-if="show_course_options">
										{{ item.hours_left }}
									</td>

									<td v-if="show_course_options">

										<div class="d-flex">
											<div class="progress-icon"  :class="[item.status_str]"></div>

											<template v-if="item.status_str == 'approved'">
												<div class="progress-icon download" @click="downloadCert(item.certificate_url)">

					            				</div>
											</template>
										</div>
									</td>

									<td v-if="show_course_options">
										<span :class="{ 'start-date-not-ready bold' : provider_due_date_not_started(item.starting_date)}">
											{{ item.starting_date | format_date }}
										</span>
									</td>
									<td v-if="show_course_options">
										<span :class="{ 'due-date-expired bold' : item.due_date_expired == 1 }">
											{{ item.due_date | format_date }}
										</span>
									</td>
									<td class="pb-1">
										<div class="status_container">
											<provider-status-action
                      :key="item.id"
                      v-if="can_bulk_action_providers && user_meta_actions.includes('deactivate_activate_provider_from_the_agency')"
											:user_status="item.provider_status_id"
                      :provider="item"
                      @updateStatusProvider="updateStatusProvider"
                      />
											<!-- <provider-status-action
                      :key="item.id"
                      v-if="can_bulk_action_providers_in_course && user_meta_actions.includes('deactivate_activate_provider_from_a_program')"
											:user_status="item.provider_status_id"
                      :provider="item"
                      @updateStatusProvider="updateStatusProviderProgram"
                      /> -->
                       <toggle-button v-if="can_bulk_action_providers_in_course && user_meta_actions.includes('deactivate_activate_provider_from_a_program')"
											v-model="item.course_active ? true : false"  class="mt-1 ml-2"
											:labels="false" :width="50"
											:color="{ checked : green, unchecked : red, disabled : '#CCCCCC' }" :sync="true"
											@change="toggleProviderCourse(item)"
										/>
										</div>
<!--
										<provider-status-action
										v-if="can_bulk_action_providers_in_course && user_meta_actions.includes('deactivate_activate_provider_from_a_program')"
										:user_status="'active'"/> -->

										<!-- toggle button for organization -->
										<!-- <toggle-button  v-if="can_bulk_action_providers && user_meta_actions.includes('deactivate_activate_provider_from_the_agency')"
											v-model="item.active ? true : false" class="mt-1 ml-2"
											:labels="false" :width="50"
											:color="{ checked : green, unchecked : red, disabled : '#CCCCCC' }" :sync="true"
											@change="toggleProvider(item)"
										/>			 -->

										<!-- toggle button for course -->
										<!-- <toggle-button v-if="can_bulk_action_providers_in_course && user_meta_actions.includes('deactivate_activate_provider_from_a_program')"
											v-model="item.course_active ? true : false" class="mt-1 ml-2"
											:labels="false" :width="50"
											:color="{ checked : green, unchecked : red, disabled : '#CCCCCC' }" :sync="true"
											@change="toggleProviderCourse(item)"
										/> -->
									</td>
								<!-- New Actions dots -->
								<td class="text-center" v-if="user_role==='csm' || user_role === 'organization'">
									<div class="trigger-hidden-content ml-1 d-inline-block">
										<span class=" button">
											<img width="15" src="../../assets/images/icons/solid/ellipsis-h_white.svg">
										</span>
										<div class="hidden-content hc-right-bottom">
										<div>
											<ul class="list-unstyled text-left">
											<template>
												<!-- New User Login SSO -->
											<li :class="{ 'input-disabled' : item.sign_up!=1}"
											v-if="user_role==='csm'"
											class="pb-2 pt-2 d-flex align-items-center
											cursor-pointer" @click="loginSSO(item)"
											>
											<!-- <div class="trigger-hidden-content ml-1 d-inline-block"> -->
												<i class="fa fa-sign-in fa-ninja fa-ninja-black" aria-hidden="true" style="vertical-align: baseline"></i>
												<small class="ml-1">User Login</small>
												<!-- </div> -->
												</li>
											<li :class="{ 'input-disabled' : item.sign_up!=0}"  class="pb-2 pt-2 d-flex align-items-center
											cursor-pointer"
											v-if="user_role==='csm'" @click="openBulkModal('sign_up_sso', item)"
											>
											<!-- <div class="trigger-hidden-content ml-1 d-inline-block"> -->
												<i class="fa fa-sign-in fa-ninja fa-ninja-black" aria-hidden="true" style="vertical-align: baseline"></i>
												<small class="ml-1">User Sign Up</small>
												<!-- </div> -->
											</li>
											<li  class="pb-2 pt-2 d-flex align-items-center cursor-pointer"	>
											<router-link v-if="user_role==='csm'" :to="{ name:user_role+'.providers.detail', params : { id : item.id }, query:{agency_id: agency_info} }" tag="a" target="_blank">

												<i class="fa
												fa-info-circle fa-ninja fa-ninja-black" style="vertical-align: baseline"></i>
												<small class="ml-1">View Details</small>
												</router-link>
											<router-link v-if="user_role==='organization'" :to="{ name:user_role+'.providers.detail', params : { id : item.id } }" tag="a" target="_blank">

												<i class="fa
												fa-info-circle fa-ninja fa-ninja-black" style="vertical-align: baseline"></i>
												<small class="ml-1">View Details</small>
												</router-link>
												</li>
												<password-action
												:user_role="user_role"
												:checked_user="1" :item="item" :sign_up="item.sign_up"></password-action>
											</template>
											</ul>
										</div>
										</div>
									</div>
								</td>

								</tr>
							</tbody>
						</table>
					</div>
					<div class="filters lightgray-content ml-4" :class="{ 'active' : show_filters }" >

						<div class="d-flex justify-content-end">

							<button type="button" @click="apply" class="button mr-2 medium-button">Apply</button>
							<!--
							<button type="button" class="button mr-2 medium-button" id="my-saved-filters-button" @click="showMySavedFilters(83, 385)">My Saved filters</button>
						-->
							<!-- only save filter when filter_edited = true -->
							<button type="button" @click="saveFilter" :disabled="!filter_edited"  class="button darkgreen-content mr-2 medium-button">Save</button>
							<button type="button" @click="resetFilters(true)" class="button red-content medium-button">Clear</button>
						</div>

						<div class="row">
							<div class="col-12">
								<!-- employee filters -->
								<div class="green bold mb-1 h6 mt-1">Employees</div>

								<div class="input-content input-content-horizontal input-content-no-mb">
									<label>Sign up</label>
									<v-select :searchable="true" track-by="id" label="str" v-model="filters.sign_up" :options="selects.sign_up" class="green bg-white v-select-xs">
									</v-select>
								</div>
								<!--
								<div class="input-content input-content-horizontal input-content-no-mb">
									<label>Language</label>
									<v-select  :searchable="true" track-by="id" label="str" v-model="filters.language" :options="selects.languages" :disabled="true">
									</v-select>
								</div>
								-->
							</div>
							<div class="col"></div>
						</div>
						<div class="row">
							<!-- agency filters -->
							<div class="col-12">
								<div class="green bold mb-1 h6 mt-1">Agency</div>

								<div class="input-content input-content-horizontal">
									<label>Discipline</label>
									<v-select :searchable="true" track-by="id" label="name"
									v-model="discipline_section_only_"
									:reduce="name => name.id"
									:options="discipline_section_first" class="green bg-white v-select-xs mr-2 width-60">
									</v-select>
									<v-select multiple :searchable="true" track-by="id" label="name"
									:value="discipline_array"
									:reduce="name => name.id"
									:options="selects.disciplines" class="green bg-white v-select-xs v-select-no-height">
									</v-select>
								</div>
								<div class="input-content input-content-horizontal">
									<label></label>
									<v-select :searchable="true" track-by="id" label="name"
									:value="discipline_section_and_not"
									:options="discipline_section_second"
									:disabled="true"
									:reduce="name => name.id"
									class="green bg-white v-select-xs mr-2 width-60 hide_arrow"
									:class="{'input-disabled': discipline_section_only_.id == 1}">
									</v-select>
									<v-select multiple :searchable="true" track-by="id" label="name"
									ref="discipline_and_not"
									:value="discipline_array_and_not"
									:reduce="name => name.id"
									:disabled="discipline_section_only_.id == 1"
									:options="and_not_disciplines" class="green bg-white v-select-xs v-select-no-height"
									:class="{'input-disabled': discipline_section_only_.id == 1}">
									</v-select>
								</div>

								<div class="input-content input-content-horizontal">
									<label>Location</label>
									<v-select  :searchable="true" track-by="id" label="name" v-model="filters.location"
									@input="locationChanged($event)"
									:options="selects.locations" class="green bg-white v-select-xs">
									</v-select>
								</div>
								<div :class="{'input-disabled not-allowed': !location_has_children}" class="input-content input-content-horizontal">
									<label>Sub Location</label>
									<v-select  :searchable="true" track-by="id" label="name" v-model="filters.sub_location" :options="location_children_options" class="green bg-white v-select-xs">
									</v-select>
								</div>
								<div class="input-content input-content-horizontal">
									<label>Languages</label>
									<v-select multiple :searchable="true" track-by="id" label="name"
									:value="language_array_"
									:reduce="name => name.id"
									:options="selects.languages" class="green bg-white v-select-xs">
									</v-select>
								</div>

								<!-- <div class="input-content input-content-horizontal"> -->
									<!-- <div class="box">
										 <date-picker v-model="filters.hiring_date" type="date" range placeholder="Select date range"></date-picker>
									</div> -->

								<div class="input-content-horizontal">
									<label>Employment Date</label>
									<date-picker-view @emitUpdatedDate="emitUpdatedDate" :mode="'range'"
									:filter_object="'filters'"
									:field_to_update="'hiring_date'"
									:date_format_dd_mm_yy="false"
									:generic_date="filters.hiring_date" />
									<!-- <date-picker v-model="filters.hiring_date" range :format="'MM-DD-YYYY'"
												:placeholder="'Pick a date'" :range-separator="' to '"
												:lang="{ formatLocale : { 'firstDayOfWeek' : 1 } }"
												:valueType="'YYYY-MM-DD'"></date-picker> -->

								</div>

								<div class="input-content input-content-horizontal">
									<label>Employee Status</label>
									<v-select multiple :searchable="true" ref="datepicker" track-by="id" label="name"
										:value="status_array_"
										:reduce="name => name.id"
										:options="selects.active" class="green bg-white v-select-xs">
									</v-select>
								</div>
								<div class="input-content input-content-horizontal">
									<label>Applicants</label>
									<v-select :searchable="true" ref="datepicker" track-by="id" label="str" v-model="filters.applicant" :options="selects.applicants" class="green bg-white v-select-xs">
									</v-select>
								</div>
                <!-- <div class="form-group">
                    <div class="checkbox-container squared">
                      <input id="is_applicant"
                      type="checkbox" v-model="filters.is_applicant"/>
                      <label for="is_applicant" style="width:auto;">Is Applicant</label>
                    </div>
                  </div> -->

								<!-- <div class="input-content input-content-horizontal">
									<label>RN</label>
									<v-select  :searchable="true" track-by="id" label="email" v-model="filters.approving" :options="selects.approving" class="green bg-white v-select-xs">
									</v-select>
								</div>

								<div class="input-content input-content-horizontal">
									<label>Coordinator</label>
									<v-select :searchable="true" track-by="email" label="email" v-model="filters.coordinator" :options="selects.coordinators" class="green bg-white v-select-xs">
									</v-select>
								</div> -->

							</div>

							<!-- course filters -->
							<div class="col-12">
								<div class="green bold mb-2 h6 mt-2">Program</div>

								<div class="input-content input-content-horizontal">
									<label>Program</label>
									<v-select :searchable="true" track-by="value" label="label" :options="selects.courses" v-model="filters.course"
												class="green bg-white v-select-xs v-select-no-height" multiple>
									</v-select>
								</div>
								<div class="input-content input-content-horizontal" :class="{ 'input-disabled' : !show_course_options }">
									<label>Program Status</label>
									<v-select :options="selects.course_active" v-model="filters.course_active" track-by="id" label="str" class="green bg-white v-select-xs"
									 :disabled="!show_course_options"></v-select>
								</div>

								<div class="input-content input-content-horizontal" style="height: 30px;">
									<label>Completion</label>
									<vue-slider v-model="completion" :options="{ 'min' : 0, 'max' : 100 }" :tooltip-formatter="'{value}%'"
											@change="completionSliderChange"
												></vue-slider>
								</div>
								<!-- <div class="input-content input-content-horizontal"  :class="{ 'input-disabled' : !show_course_options }"> -->
									<div class="input-content-horizontal"  :class="{ 'input-disabled' : !show_course_options }">
									<label>Completion Date</label>
										<date-picker-view
										 @emitUpdatedDate="emitUpdatedDate"
										:mode="'range'"
										:date_format_dd_mm_yy="false"
										:generic_date="filters.completion_date"
										:filter_object="'filters'"
										:field_to_update="'completion_date'"
										:disabled="!show_course_options"/>
									<!-- <date-picker v-model="filters.completion_date" :range="true" :format="'MM-DD-YYYY'"
												:placeholder="'Pick a date'" :range-separator="' to '"
												:lang="{ formatLocale : { 'firstDayOfWeek' : 1 } }"
												:valueType="'YYYY-MM-DD'" :disabled="!show_course_options"></date-picker> -->
								</div>
								<!-- <div class="input-content input-content-horizontal"  :class="{ 'input-disabled' : !show_course_options }"> -->
								<div class="input-content-horizontal"  :class="{ 'input-disabled' : !show_course_options }">
									<label>Approval Date</label>
									<date-picker-view
										@emitUpdatedDate="emitUpdatedDate"
										:mode="'range'"
										:date_format_dd_mm_yy="false"
										:generic_date="filters.approval_date"
										:filter_object="'filters'"
										:field_to_update="'approval_date'"
										:disabled="!show_course_options"/>
									<!-- <date-picker v-model="filters.approval_date" :range="true" :format="'MM-DD-YYYY'"
												:placeholder="'Pick a date'" :range-separator="' to '"
												:lang="{ formatLocale : { 'firstDayOfWeek' : 1 } }"
												:valueType="'YYYY-MM-DD'" :disabled="!show_course_options"></date-picker>									 -->
								</div>

								<div class="input-content input-content-horizontal" :class="{ 'input-disabled' : !show_course_options }">
									<label>Status</label>
									<v-select :options="selects.course_status" v-model="filters.course_status" track-by="id" label="str" class="green bg-white v-select-xs" :disabled="!show_course_options"></v-select>
								</div>

								<div class="input-content input-content-horizontal" :class="{ 'input-disabled' : !show_course_options }">
									<label>Duration Method</label>
									<v-select :options="selects.duration_method" v-model="filters.duration_method" track-by="id" label="str" class="green bg-white v-select-xs" :disabled="!show_course_options"></v-select>
								</div>
								<!-- <div class="input-content input-content-horizontal"  :class="{ 'input-disabled' : !show_course_options }">
									<label>Learner Support</label>
									<v-select :searchable="true" track-by="id" label="email" v-model="filters.supporting" :options="selects.supporting" class="green bg-white v-select-xs" :disabled="!show_course_options">
									</v-select>
								</div>
								<div class="input-content input-content-horizontal" :class="{ 'input-disabled' : !show_course_options }">
									<label>Agency Manager</label>
									<v-select :searchable="true" track-by="id" label="email" v-model="filters.manager" :options="selects.managers" class="green bg-white v-select-xs" :disabled="!show_course_options">
									</v-select>
								</div> -->


								<div class="input-content-horizontal" :class="{ 'input-disabled' : !show_course_options }">
								<!-- <div class="input-content input-content-horizontal" :class="{ 'input-disabled' : !show_course_options }"> -->
									<label>Start Date</label>
									<date-picker-view
									@emitUpdatedDate="emitUpdatedDate"
									:mode="'range'"
									:give_border="true"
									:date_format_dd_mm_yy="false"
									:filter_object="'filters'"
									:field_to_update="'start_date'"
									:generic_date="filters.start_date"

									disabled="!show_course_options"/>
									<!-- <date-picker v-model="filters.start_date" :range="true" :format="'MM-DD-YYYY'"
												:placeholder="'Pick a date'" :range-separator="' to '"
												:lang="{ formatLocale : { 'firstDayOfWeek' : 1 } }"
												:valueType="'YYYY-MM-DD'" :disabled="!show_course_options"></date-picker>										 -->
								</div>

								<!-- <div class="input-content input-content-horizontal" :class="{ 'input-disabled' : !show_course_options }"> -->
								<div class="input-content-horizontal" :class="{ 'input-disabled' : !show_course_options }">
									<label>Due Date</label>
									<date-picker-view @emitUpdatedDate="emitUpdatedDate" :mode="'range'"
									:date_format_dd_mm_yy="false"
									:filter_object="'filters'"
									:field_to_update="'due_date'"
									:generic_date="filters.due_date"
									disabled="!show_course_options"/>
									<!-- <date-picker v-model="filters.due_date" :range="true" :format="'MM-DD-YYYY'"
												:placeholder="'Pick a date'" :range-separator="' to '"
												:lang="{ formatLocale : { 'firstDayOfWeek' : 1 } }"
												:valueType="'YYYY-MM-DD'" :disabled="!show_course_options"></date-picker>	 -->
								</div>
							</div>
						</div>

					</div>
				</div>


				<div class="row justify-content-between ">
					<div class="col-12 col-lg-6">
						<span>Showing {{ from }} to {{ to }} of {{ total_rows }}</span>
					</div><!--col-->
					<div class="col-12 col-lg-6">
						<b-pagination align="right" :total-rows="total_rows" v-model="current_page" :per-page="parseInt(per_page)" @change="setPage">
		    			</b-pagination>
					</div><!--col-->
				</div><!--row-->
			</div>
		</div>

		<!-- modal create filter -->
		<b-modal v-model="show_modal_create_filter" title="New filter">


   			<div class="input-content mr-2">
   				<label>Name</label>
   				<input type="text" name="name" v-model="new_filter_name"/>
   			</div>

			<div slot="modal-footer" class="w-100 row">
				<div class="col-6">
					<button class="button gray-content large-button w-100" @click="show_modal_create_filter = false">Cancel</button>
				</div><!--col-->
				<div class="col-6">
					<button class="button large-button w-100" @click="createFilter">Save</button>
				</div><!--col-->
			</div>

		</b-modal>

		<!-- modal delete filter -->
		<b-modal v-model="show_modal_delete_filter" title="Delete filter">

	   		<template v-if="filter_to_delete != null">
				Are you sure you want to delete the filter <strong>{{ filter_to_delete.name }}</strong>?
			</template>

			<div slot="modal-footer" class="w-100 row">
				<div class="col-6">
					<button class="button gray-content large-button w-100" @click="show_modal_delete_filter = false">Cancel</button>
				</div><!--col-->
				<div class="col-6">
					<button class="button large-button w-100" @click="deleteFilter()">Yes</button>
				</div><!--col-->
			</div>

		</b-modal>

		<!-- modals bulk -->

		<!-- modal organization -->

		<!-- modal activate providers -->
		<b-modal v-model="bulk_modals.show_activate" title="Activate employees" ok-title="Activate" @ok="activateProviders">
			<template v-if="select_all">
				<p class="text-center">You will activate all the employees.</p>
			</template>
			<template v-else>
				<p class="text-center" v-if="bulk_selection.length > 1">You will activate the following employees:</p>
				<p class="text-center" v-if="bulk_selection.length === 1">You will activate the following employee:</p>
				<p class="text-center" v-if="bulk_selection.length === 0">No employees selected</p>

				<ul class="list-unstyled list-2-columns">
					<li v-for="provider in bulk_selection">
						{{ provider.last_name }} {{ provider.first_name }}
					</li>
				</ul>
			</template>
		</b-modal>
		<b-modal v-model="bulk_modals.show_terminate" title="Terminate employees" ok-title="Terminate" @ok="terminateProviders">
			<template v-if="select_all">
				<p class="text-center">You will terminate all the employees.</p>
			</template>
			<template v-else>
				<p class="text-center" v-if="bulk_selection.length > 1">You will terminate the following employees:</p>
				<p class="text-center" v-if="bulk_selection.length === 1">You will terminate the following employee:</p>
				<p class="text-center" v-if="bulk_selection.length === 0">No employees selected</p>

				<ul class="list-unstyled list-2-columns">
					<li v-for="provider in bulk_selection">
						{{ provider.last_name }} {{ provider.first_name }}
					</li>
				</ul>
			</template>
		</b-modal>

		<!-- modal deactivate providers -->
		<b-modal v-model="bulk_modals.show_remove_course" title="Remove employees from program" ok-title="Remove" @ok="removeProviders">
			<template>
				<p class="text-center" v-if="bulk_selection.length > 1">The selected employees will be removed from the program. <br><br>This action cannot be undone</p>
				<p class="text-center" v-if="bulk_selection.length === 1">The selected employee will be removed from the program. <br><br>This action cannot be undone</p>
				<p class="text-center" v-if="bulk_selection.length === 0">No employees selected</p>

				<ul class="list-unstyled list-2-columns">
					<li v-for="provider in bulk_selection">
						{{ provider.last_name }} {{ provider.first_name }}
					</li>
				</ul>
			</template>
		</b-modal>
		<b-modal v-model="bulk_modals.show_deactivate" title="Place employees On Hold" ok-title="Place On Hold" @ok="deactivateProviders">
			<template v-if="select_all">
				<p class="text-center">All the employees will be placed On Hold.</p>
			</template>
			<template v-else>
				<p class="text-center" v-if="bulk_selection.length > 1">The following employees will be placed On Hold:</p>
				<p class="text-center" v-if="bulk_selection.length === 1">The following employee will be placed On Hold:</p>
				<p class="text-center" v-if="bulk_selection.length === 0">No employees selected</p>

				<ul class="list-unstyled list-2-columns">
					<li v-for="provider in bulk_selection">
						{{ provider.last_name }} {{ provider.first_name }}
					</li>
				</ul>
			</template>
		</b-modal>

		<!-- modal add providers to program  @hide.prevent($event)="cleanSessionForm()"-->
		<b-modal v-model="bulk_modals.show_add_to_program" title="Add employees to program"  :ok-disabled="add_program_disabled" ok-title="Add employees to program" @ok.prevent="addProvidersToCourse($event)" id="modal-add-providers-to-course">
			<template >
				<p v-if="select_all" class="text-center">You will add to a program all the employees.</p>
				<p v-else class="text-center">You will add to a program following employees:</p>
			</template>
			<template>

				<ul class="list-unstyled list-2-columns">
					<li v-for="provider in bulk_selection">
						{{ provider.last_name }} {{ provider.first_name }}
					</li>
				</ul>

				<div class="row">

					<div class="col">
						<div v-if="add_to_program_courses_in_class.length > 0" class="form-group">
							<label>Program Type</label>
							<div  class="mt-2 radio-button">
							<input type="radio" v-model="add_program_type" class="" id="one" value="in-class" >
								<label for="one">In Class Program</label>
								<input type="radio"  v-model="add_program_type" class=" ml-2" id="two" value="online">
								<label for="two">Online Programs</label>
							</div>
						</div>
						<div class="input-content">
							<label class="mb-1">Program*</label>

							<v-select :options="add_to_program_courses" class="green green-dark bg-gray v-select-no-height" v-model="add_to_program.course" :show-labels="true" label="label" :multiple="add_program_type == 'online'"  name="course"></v-select>
							<span class="input-error-msg" v-if="show_add_to_program_errors">Program is mandatory</span>
						</div>
					</div>
				</div>		
				
				<div class="row">

					<div class="col">
						
						<div v-if="add_program_type == 'online'" class="form-group input-content">
							<label>Program start date by*</label>
							<v-select class="mb-2"  :searchable="false"  name="starting_date_method_" v-model="add_to_program.starting_date_method"
									:options="program_start_date_options">
							</v-select>
							<span class="input-error-msg"  v-if="show_add_to_program_errors">Program start date is mandatory</span>
						</div>

						
					</div>

					<div class="col">
						<div v-if="add_program_type == 'online'" >
							<div v-if="custom_start_date_chosen" class="form-group input-content">
								<label>Start date*</label>
								<date-picker-view
								v-model="add_to_program.starting_date"
								:give_border="true"
								:mode="'single'"
								:date_format_dd_mm_yy="false"
								:filter_object="'add_to_program'"
								:field_to_update="'starting_date'"
								:generic_date="add_to_program.starting_date" 
								/>
								<!-- <datetime placeholder="Start date*" type="date" v-model="add_to_program.starting_date" name="start_date"></datetime>
								<span class="input-error-msg"  v-if="show_add_to_program_errors" >Start date is mandatory</span> -->
							</div>
						</div>

						<div v-if="add_program_type == 'online'" >
							<div v-if="custom_start_plus_days" class="form-group input-content">
								<label>Plus days (optional)</label>
								<input placeholder="Set a number" type="number" min="0" 
									v-model="add_to_program.starting_date_plus_x_days" />

								<span class="input-error-msg"  v-if="show_add_to_program_errors">Due date is mandatory</span>
							</div>
						</div>
					</div>
				</div>
				
				<div class="row">
					<div class="col">
						<div v-if="add_program_type == 'online'" class="form-group input-content">
							<label>Program due date by*</label>
							<v-select class="mb-2"  :searchable="false"  name="timing_method_" v-model="add_to_program.timing_method"
									:options="program_due_date_options">
							</v-select>
							<span class="input-error-msg"  v-if="show_add_to_program_errors">Program duration by is mandatory</span>
						</div>
						<div v-if="add_program_type == 'in-class' && add_to_program.course">
							<session-create-view :selects="add_to_program.course" :provider_view="true" :no_border="true"  :table_view="true" @fetchSessionData="fetchSessionData" @addProvidersToProgramWithSession="addProvidersToProgramWithSession" @addProgramButtonDisable="addProgramButtonDisable" @sessionCreatingView="sessionCreatingView" />
							<span class="mt-3">
							Note: only employees who are not already enrolled to this program will be added to the session
							</span>
						</div>
					</div>
					<div class="col">
						<div v-if="add_program_type == 'online'">
							<div v-if="custom_due_date_chosen" class="form-group input-content">
								<label>Due date</label>
									<date-picker-view
									@emitUpdatedDate="emitUpdatedDate"
									:mode="'single'"
									:date_format_dd_mm_yy="false"
									:filter_object="'add_to_program'"
									:field_to_update="'duration_date'"
									:generic_date="add_to_program.duration_date" />
								<!-- <datetime placeholder="Due date*" type="date" v-model="add_to_program.duration_date" name="duration_date"></datetime> -->
								<span class="input-error-msg"  v-if="show_add_to_program_errors" >Due date is mandatory</span>
							</div>
						</div>
						<div v-if="add_program_type == 'online'" >
							<div v-if="custom_due_plus_days" class="form-group input-content">
								<label>Plus days (optional)</label>
								<input placeholder="Set a number" type="number" min="0" 
									v-model="add_to_program.duration_days_from_start_date" />

								<span class="input-error-msg"  v-if="show_add_to_program_errors">Due date is mandatory</span>
							</div>
						</div>

					</div>
					
					<h5  style="text-align: center; margin: 20px 0 0 75px;">
        			Terminated employees will not be added to programs.</h5>						
				</div>
			</template>
		</b-modal>

		<!-- modal courses -->

		<!-- modal activate providers -->
		<b-modal v-model="bulk_modals.show_activate_course" title="Activate employees in program" ok-title="Activate" @ok="activateProvidersInCourse">

			<template v-if="filters.course.length == 1">
				<template v-if="select_all">
					<p class="text-center">All the employees will be activated in the program {{ filters.course[0].label }}.</p>
				</template>
				<template v-else>
					<p class="text-center" v-if="bulk_selection.length > 1">The selected employees will be activated in the program {{ filters.course[0].label }}:</p>
					<p class="text-center" v-if="bulk_selection.length === 1">The selected employee will be activated in the program {{ filters.course[0].label }}:</p>
					<p class="text-center" v-if="bulk_selection.length === 0">No employees selected</p>

					<ul class="list-unstyled list-2-columns">
						<li v-for="provider in bulk_selection">
							{{ provider.last_name }} {{ provider.first_name }}
						</li>
					</ul>
				</template>
			</template>

		</b-modal>

		<!-- modal deactivate providers -->
		<b-modal v-model="bulk_modals.show_deactivate_course" title="Deactivate employees from program" ok-title="Deactivate" @ok="deactivateProvidersInCourse">
			<template v-if="filters.course.length == 1">
				<template v-if="select_all">
					<p class="text-center">All the employees will be deactivated from the program {{ filters.course[0].name }}.</p>
				</template>
				<template v-else>
					<p class="text-center" v-if="bulk_selection.length > 1">The selected employees will be deactivated from the program:</p>
					<p class="text-center" v-if="bulk_selection.length === 1">The selected employee will be deactivated from the program:</p>
					<p class="text-center" v-if="bulk_selection.length === 0">No employees selected</p>

					<ul class="list-unstyled list-2-columns">
						<li v-for="provider in bulk_selection">
							{{ provider.last_name }} {{ provider.first_name }}
						</li>
					</ul>
				</template>
			</template>
		</b-modal>

		<!-- modal edit due date -->
		<b-modal v-model="bulk_modals.show_edit_due_date" title="Edit due date" ok-title="Edit" @ok="editDueDateProvidersInCourse">
			<template v-if="filters.course.length == 1">
				<template v-if="select_all">
					<p class="text-center">You will edit the due date for all employees in the program {{ filters.course[0].label }}.</p>
				</template>
				<template v-else>
					<p class="text-center">You will edit the due date for the following employees in the program {{ filters.course[0].label }}:</p>

					<ul class="list-unstyled list-2-columns">
						<li v-for="provider in bulk_selection">
							{{ provider.last_name }} {{ provider.first_name }}
						</li>
					</ul>
				</template>

				<div class="form-group input-content">
					<label>Due date</label>

					<datetime @input="show_error_due_date = true" v-model="edit_due_date" hidden-name="edit_due_date" name="edit-due-date" placeholder="New due date" ></datetime>

					<span class="input-error-msg" v-if="show_error_due_date && edit_due_date == ''">The due date is mandatory</span>
				</div>

				<div class="form-group">
					<div class="checkbox-container squared">
						<input id="notify-employees-due-date" type="checkbox" v-model="notify_edit_due_date"/>
						<label for="notify-employees-due-date" style="width:auto;">Notify employees</label>
					</div>
				</div>

				<div class="text-right">
					<small><i>The completed users will not be updated</i></small>
				</div>
			</template>
		</b-modal>

		<!-- modal edit start date -->
		<b-modal v-model="bulk_modals.show_edit_start_date" title="Edit start date" ok-title="Edit" @ok="editStartDateProvidersInCourse">
			<template v-if="filters.course.length == 1">
				<template v-if="select_all">
					<p class="text-center">You will edit the start date for all employees in the program {{ filters.course[0].label }}.</p>
				</template>
				<template v-else>
					<p class="text-center">You will edit the start date for the following employees in the program {{ filters.course[0].label }}:</p>

					<ul class="list-unstyled list-2-columns">
						<li v-for="provider in bulk_selection">
							{{ provider.last_name }} {{ provider.first_name }}
						</li>
					</ul>
				</template>

				<div class="form-group input-content">
					<label>Start date</label>

					<datetime @input="show_error_due_date = true" v-model="edit_start_date" hidden-name="edit_start_date" name="edit-start-date" placeholder="New start date" ></datetime>

					<span class="input-error-msg" v-if="show_error_start_date && edit_start_date == ''">The start date is mandatory</span>
				</div>

				<!-- <div class="form-group">
					<div class="checkbox-container squared">
						<input id="notify-employees-due-date" type="checkbox" v-model="notify_edit_start_date"/>
						<label for="notify-employees-due-date" style="width:auto;">Notify employees</label>
					</div>
				</div>

				<div class="text-right">
					<small><i>The completed users will not be updated</i></small>
				</div> -->
			</template>
		</b-modal>

		<!-- modal approve providers -->
		<b-modal v-model="bulk_modals.show_approve" title="Approve employees" ok-title="Confirm" @ok="approveProvidersInCourse">
			<template v-if="filters.course.length == 1">
				<template v-if="select_all">
					<p class="text-center">You will approve all employees in the program {{ filters.course[0].label }}.</p>
				</template>
				<template v-else>
					<p class="text-center">You will approve the following employees in the program {{ filters.course[0].label }}:</p>

					<ul class="list-unstyled list-2-columns">
						<li v-for="provider in bulk_selection" v-if="provider.status_str == 'awaiting'">
							{{ provider.last_name }} {{ provider.first_name }}
						</li>
					</ul>

				</template>
			</template>
		</b-modal>

		<!-- modal send message -->
		<b-modal v-model="bulk_modals.show_send_message" title="Send message" ok-title="Send" @ok="sendMessageInCourse">
			<template v-if="filters.course.length == 1">
				<template v-if="select_all">
					<p class="text-center">You will send a message to all employees in the program {{ filters.course[0].label }}.</p>
				</template>
				<template v-else>
					<p class="text-center">You will send a message to the following employees in the program {{ filters.course[0].label }}:</p>

					<ul class="list-unstyled list-2-columns">
						<li v-for="provider in bulk_selection">
							{{ provider.last_name }} {{ provider.first_name }}
						</li>
					</ul>

				</template>

				<div class="input-content mb-2">
					<textarea rows="13" v-model="message_text"></textarea>
				</div>

				<small>
					<p class="mt-2 mb-1">You can personalize the message with: </p>
					<ul>
						<li>%FIRST_NAME%: first name of the employee</li>
						<li>%LAST_NAME%: last name of the employee</li>
					</ul>
				</small>
			</template>
		</b-modal>

			<!-- modal delete HHA -->
		<b-modal v-model="bulk_modals.show_delete_user"  v-if="bulk_selection.length === 1" title="Delete HHa" @ok="deleteProvider(bulk_selection)" cancel-title="No" ok-title="Yes">
			<div>
				<p class="mb-2">
					Are you sure you want to delete the HHA {{ bulk_selection[0].first_name }} {{ bulk_selection[0].last_name }}?
				</p>
			</div>
		</b-modal>
		<password-reset v-if="user_role==='csm' || user_role ==='organization'" :bulk_modals="bulk_modals" 												@closeBulkModal="closeBulkModal" :select_all="select_all" :filter_status="filter_status"
		:bulk_selection="bulk_selection" :agency_id="agency_info" :search_key="search"

		@closeLoadingTableIcon="closeLoadingTableIcon"></password-reset>
	</div>
</template>

<script>
	import ProvidersMixin from '../shared/ProvidersMixin'
	import { EventBus } from './../../event_bus.js';
	import DatePickerView from './../shared/inputs/DatePickerView.vue'
	import DatePickerMixin from './../shared/inputs/DatePickerMixin'
	import ProviderStatusAction from './../shared/inputs/ProviderStatusAction.vue'

	import sessionCreateView from './../shared/sessionCreateView.vue'
	export default{
		components : {
			DatePickerView,
			sessionCreateView,
			ProviderStatusAction
		},
		mixins: [ProvidersMixin,DatePickerMixin],
		props:["AgencyView","agency"],
		data : function() {
			return {
				showPopup : false,
				customMessage: null,

				session_is_new: false,
				session_data_add_program: null,
				add_program_disabled: false,
				add_program_type: "online",
				add_to_program_courses: [],
				add_to_program_courses_in_class:[],
				componentKey:0,
				checked_user:'',
				agency_info: this.$route.params.agency_id,
				user_role:'',
				send_sms_to_all:false,
				show_send_sms:false,
				no_program: false,
				providers : [],
				current_page : 1,
				total_rows : 15,
				per_page  : 50,
				from : 0,
				to : 0,
				loading_table_providers : false,

				loading_export : false,

				my_filters : {

				},
				program_start_date_options: [
					{ value: 2, label: "Custom Date" },
					{ value: 3, label: "Anniversary Date" },
					{ value: 4, label: "Anniversary Month" }
				],
				program_due_date_options: [
					{ value: 1, label: "December 31st" },
					{ value: 4, label: "Custom Date" },
					{ value: 5, label: "Number of Days from Start Date" },
					{ value: 2, label: "One year from Start Date" }
				],
				filter_selected : null,
				filter_selected_initial_value : null,
				filter_selected_edited : false,
				new_filter_name : '',
				old_filter_name : '',
				show_modal_create_filter : false,

				show_filters : false,
				show_my_saved_filters : false,

				search_timeout : null,

				time1 : null,
				show_course_options : false,
				show_progress_bar : false,
				completion : [0, 100],
				filters : {
					completion : [0, 100],
					sign_up : null,
					discipline : null,
					languages:null,
					location : null,
					sub_location: null,
					hiring_date : {
						from : '',
						to : ''
					},
					active : null,

					coordinator : null,
					supporting : null,
					approving : null,
					manager : null,

					course : [],
					course_active : null,
					course_status : null,
					completion_date : {
						from : '',
						to :''
					},
					approval_date : {
						from : '',
						to : ''
					},
					start_date : {
						from : '',
						to : ''
					},
					due_date : {
						from : '',
						to : ''
					},
					completion : {
						from : 0,
						to : 100
					},
					organization_id:'',
					only_ids:0,
          applicant: null

				},
				agencyIds:'',
				// agency:'',

				filter_applied : 'None',
				search : '',
				generatedPassword:'',

				//the selects
				selects : {
					sign_up : [
						{ id : -1, str : 'All' },
						{ id : 0, str : 'No' },
						{ id : 1, str : 'Yes' }
					],
					languages : [],
					disciplines : [],
					locations : [],
          applicants : [
						{ id : -1, str : 'All' },
						{ id : 0, str : 'No' },
						{ id : 1, str : 'Yes' }
					],
					active : [
						{ id : 'all', name : 'All' }
					],
					approving : [],
					supporting : [],
					coordinators : [],
					managers : [],

					courses : [],
					agencies:[],

					course_active : [
						{ id : -1, str : 'All' },
						{ id : 0, str : 'No' },
						{ id : 1, str : 'Yes' }
					],
					course_status : [
						{ id : 'all', str : 'All' },
						{ id : 'in-progress', str : 'In progress' },
						{ id : 'awaiting', str : 'Pending approval' },
						{ id : 'approved' , str : 'Approved' }
					],
					duration_method : [
						{ id : -1, str : 'All' },
						{ id : 1, str : 'Jan - Dec' },
						{ id : 2, str : 'By Employee Employment Date' },
						{ id: 4, str: "By Custom Date" },
					]
				},

				my_filters_right : 238,
				my_filters_top : 0,
				password_index:0,
				show_modal_delete_filter : false,
				filter_to_delete : null,

				show_select_all : false,
				checkbox_bulk : false,
				select_all : false,

				red : this.config.COLORS.RED,
				green : this.config.COLORS.GREEN,
				remove_program_modal: false,
				//bulk actions
				bulk_modals : {
					//organization
					show_activate : false,
					show_deactivate : false,
					show_add_to_program : false,
          show_terminate: false,

					//course
					show_remove_course: false,
					show_activate_course : false,
					show_deactivate_course : false,
					show_download_certificates : false,
					show_send_message : false,
					show_approve : false,
					show_edit_due_date : false,
					show_edit_start_date : false,
					show_reset_password_email: false,
					show_reset_password_text: false,
					show_reset_password_plain: false,
					show_delete_user: false,
					show_send_sms: false,
					show_sign_up_sso: false
				},

				bulk_selection : [],
				n_bulk_selected : 0,
				edit_due_date : '',
				edit_start_date : '',
				notify_edit_due_date : false,
				notify_edit_start_date : false,
				show_error_due_date : false,
				show_error_start_date : false,
				message_text : '',

				add_to_program : {
					course : null,
					starting_date : null,
					timing_method : null,
				},
				show_add_to_program_errors : false,

				sign_ups : {
					active : 0,
					not_active : 0
				},

				completed_course : {
					completed : 0,
					not_completed : 0
				},

				loading_completed_course : false,
				loading_sign_ups : false,

				can_bulk_action_providers : false,
				can_bulk_action_providers_in_course : false,
				only_ids:[],
				checked_signups:[],
				checked_user_list:[],
				checked_user_refs:'',
				language_array_:[],
       			status_array_:[],
				discipline_array:[
					{id: '!', name:'Only'}
				],
				discipline_array_and_not:[],
				temp_current_org: this.$store.getters.getCurrentOrganization,
				user_meta_actions: localStorage.getItem('meta_actions'),
				discipline_section_first:[
					{name:'Only',id:1},
					{name:'Any',id:0}
				],
				discipline_section_second:[
					{name:'and not',id:1},
				],
				discipline_section_only_: {
					name:'Only',
					id:1
				},
				discipline_section_and_not: {
					name:'& Not',
					id:1
				},
				and_not_disciplines: []

			}
		},
		watch : {

			get_current_org: function(val){
				if(val == this.temp_current_org){
					return
				}else{
					this.temp_current_org = val
					this.hook_created();
				}
			},
			discipline_array: function(disciplines){
				//now temp_disciplines is array of disciplines that we dont want for the AND NOT dicipline array
				// we use the the whole discipline options to remove the existing selected disciplines
		        this.and_not_disciplines = this.selects.disciplines.filter(val => {
					if(!disciplines.includes(val)){
						return val
					}
				});

				//clean the selected values if any match with already selected AND NOT Discipline Dropdown
				let filtered_and_not = this.$refs.discipline_and_not.mutableValue
				disciplines.forEach(elem => {
					if(this.$refs.discipline_and_not.mutableValue.includes(elem)){
						filtered_and_not = filtered_and_not.filter(val => val != elem)
					}
				})
				this.$refs.discipline_and_not.mutableValue = filtered_and_not
				this.discipline_array_and_not = filtered_and_not

				//remove the ALL and NONE
				this.and_not_disciplines = this.and_not_disciplines.filter(elem => elem.name != 'All')
				this.and_not_disciplines = this.and_not_disciplines.filter(elem => elem.name != 'None')
				this.filterSelectionOptions(this.discipline_array, disciplines, -1)
			},
			discipline_section_only_: function(val){
				if(val.id == 1){
					this.discipline_array_and_not = []
					this.$refs.discipline_and_not.mutableValue = []
				}

			},
			language_array_: function(val){
				this.filterSelectionOptions(this.language_array_, val, '')
			},
			status_array_: function(val){
				this.filterSelectedOptionsActiveList(this.status_array_, val, 'all')
			},
			'add_to_program.course': function(val){
				//if it is in-class reset the session dropdown
				if(this.add_program_type && this.add_program_type == 'in-class'){
					EventBus.$emit('cleanSessionForm');
				}
				if(val == null) {
					return
				}
				let no_program_exists = false;
				if(Array.isArray(val)){
					no_program_exists = val.some(el => el.value == '-1')
				}else{
					no_program_exists = (val.value == '-1')
				}
				if(no_program_exists &&  val[0].value == -1){
					if(val.length == 1){
						return
					}else{
						this.add_to_program.course.splice(0,1)
					}
				}else if(no_program_exists){
					this.add_to_program.course = [{ label: "No Program", value: -1}]
				}

			},
			'filters.course': function(val){
				this.unselectAll(true);
				//check for the first load - filter might return no user so if filter used - trigger provider list function
				if(this.providers.length == 0 && val.length == 0 && this.filter_applied != 'Filtered'){
					return
				}else{
					this.getProviders(val)
				}
				//if we want to keep the user checked then just use this.clickedUserCheck();
			},
			per_page : function(per_page, old_per_page){
				if(per_page != old_per_page){
					this.getProviders();
				}
			},
			//every time we select a filter, we need to store the initial value
			filter_selected : function(value, old_value){
				//this.filter_selected_initial_value = value;
			},
			filters: {
				handler(newval,oldval){
					// if found , remove all the rest
					// If first element is No Program, and second one is different, we move the No Program to
					if(this.filters.course.length > 1){
						if(oldval.course[0].value === -1 ){
							for(let i in oldval.course){
									this.$nextTick(()=>{
										for(let i in this.filters.course){
											if(this.filters.course[i].value === -1){
												this.filters.course.splice(i, i+1)
											}
										}
									})
							}
						}
						// No Program added, clean all but No program
						if(oldval.course[oldval.course.length - 1].value === -1 ){
							for(let i in oldval.course){
									this.$nextTick(()=>{
										for(let k in this.filters.course){
											if(this.filters.course[k].value != -1){
												this.filters.course.splice(k, k+1)
											}
										}
									})
								}
							}
					}

				},
				deep:true
			},
			agency: function(newval, oldval){
				// Now when we updated  agency, reset the Program(course) section
				this.filters.course = []
			},
			add_program_type: function(val){
				//once value change update program list
				this.getAddToProgramCourses()
			}
		},

		computed : {
			custom_start_date_chosen: function(){
				if(this.add_to_program.starting_date_method){
					if(this.add_to_program.starting_date_method.value == 2){
						
						return true
					}else{
						return false

					}
				}
			},
			custom_start_plus_days: function() {
				if (this.add_to_program.starting_date_method) {
					if (this.add_to_program.starting_date_method.value == 3 || this.add_to_program.starting_date_method.value == 4) {
					return true;
					} else {
					return false;
					}
				} else {
					return false;
				}
			},
			custom_due_date_chosen: function(){
				if(this.add_to_program.timing_method){
					if(this.add_to_program.timing_method.value == 4){
						return true
					}else{
						return false

					}
				}
			},
			custom_due_plus_days: function() {
			if (this.add_to_program.timing_method) {
				if (this.add_to_program.timing_method.value == 5) {
				return true;
				} else {
				return false;
				}
			} else {
				return false;
			}
			},
			location_has_children: function(){
				if(this.filters.location  && this.filters.location.children !== 'undefined'){
					return true
				}else{
					return false
				}
			},
			location_children_options: function(){
				if(this.filters.location  && this.filters.location.children !== 'undefined'){
					return this.filters.location.children
				}else{
					return []
				}
			},
			get_current_org: function(){
				return this.$store.getters.getCurrentOrganization
			},
			filter_edited : function(){

				if(this.filter_selected){
					var filter_changed = !(JSON.stringify(this.filters) == JSON.stringify(this.filter_selected_initial_value));

					var filter_name_changed = this.old_filter_name != this.filter_selected.name;

					return (filter_changed || filter_name_changed);
				}
			},
			filter_status: function(){
				return this.filter_applied
			},
			sign_up_status: function(){
				if(this.select_all == true){
					return 0
				}
				if(this.checked_signups.length >0){
				for(let i in this.checked_signups){
					if(this.checked_signups[i].status == '0'){
						return 0
					}
				}
					return 1
				}
			},
		},

		created : function(){
			document.querySelector(".main-section").style['overflow-y'] = "hidden";

			//if not multi-user - call created functions to get data
			// if(this.get_current_org == '' && this.agency != undefined){
			// }
			if(this.user_meta_actions.length == 0){
				this.user_meta_actions = localStorage.getItem('meta_actions')
			}
			this.hook_created();
		},

		mounted : function() {
			this.getCustomMessages();
		},

		methods : {
			cleanSessionForm: function(){
				this.session_data_add_program = null
				this.add_program_type = "online"
				EventBus.$emit('cleanSessionForm');
			},
			addProgramButtonDisable: function(val){
				this.add_program_disabled = val
			},
			sessionCreatingView: function(status){
				this.session_is_new = status
			},
			// emitUpdatedDate: function(updated_field,updated_date){
			// 	if(updated_date){
			// 		this.filters[updated_field] = [
			// 			updated_date.date.start_date, updated_date.date.end_date
			// 		]
			// 	}else{
			// 		// clean date
			// 		this.filters[updated_field] = ''
			// 	}

			// },
			provider_due_date_not_started: function(date){
		     	var current_date = new Date().toISOString().slice(0, 10);
				return current_date>=date ? 0 : 1
			},
			hook_created: function(){
				this.user_role = this.$store.getters.getRole;

				EventBus.$once('organizationChanged', () => {
					if(this.agency){
						this.agency_info = this.$route.params.agency_id
					}
					this.resetBulk();
				});
				this.iniFilters();
				this.getMyFilters(false);

				let self = this;

				window.addEventListener('click', function(e){
					// close dropdown when clicked outside
					if (!self.$el.contains(e.target)){
					self.show_my_saved_filters = false;
					}
				});

				this.$root.$on('bv::modal::show', (bvEvent) => {

					if(bvEvent.target.id == 'modal-add-providers-to-course'){
						this.add_to_program = {
							course : null,
							starting_date : null,
							timing_method : null,
						}

						this.show_add_to_program_errors = false;
					}
				})
				this.getAddToProgramCourses();

			},
			resetFilters : function(load_providers){
				this.filters.sign_up = { id : -1, str : 'All' };
				this.filters.provider_status = { id : 1, name : 'Active' };
				this.filters.applicant = { id : -1, str : 'All' };
				this.filters.discipline = { id : -1, name : 'All' };
				this.discipline_section_only_ = { name: 'Only', id: 1 }
				this.discipline_array = []
				this.discipline_array.push({ id : -1, name : 'All' })
				this.filters.languages = { id : '', name : 'All' };
				this.language_array_ = []
				this.language_array_.push({
						id : '',
						name : 'All'
				})
				this.status_array_ = []
				this.status_array_.push({
						id :  1,
						name : "Active"
				})
				this.filters.location = { id : -1, name : 'All' };
				this.filters.coordinator = { id : -1, email : 'All' };
				this.filters.supporting = { id : -1, email : 'All' };
				this.filters.approving = { id : -1, email : 'All' };
				this.filters.manager = { id : -1, email : 'All' };
				this.filters.course = [];
				this.filters.course_active = { id : -1, str : 'All' };
				this.filters.course_status = { id : 'all', str : 'All' };
				this.filters.duration_method = { id : -1, str : 'All'};
				this.filters.completion = { from : 0, to : 100 };
				this.completion = [0, 100];

				EventBus.$emit('CLEAR_DATEPICKER_TEXT', {});


				this.filters.hiring_date = ['', ''];
				this.filters.completion_date = ['', ''];
				this.filters.approval_date = ['', ''];
				this.filters.start_date = ['', ''];
				this.filters.due_date = ['', ''];

				this.setDefaultFilter();

				this.filter_applied = 'None';

				if(load_providers){
					this.unselectAll(false);
					this.getProviders();
				}

			},
			iniFilters : function(){

				this.resetFilters(false);
				this.getDisciplines();
				this.getLanguages();
        this.getStatusOptions();
				this.getLocations();
				this.getCourses();
				this.getProviders();

				// this.getSubroles();
			},
			getCustomMessages : function() {
				this.$store.dispatch('getCustomMessages').then((res) => {
					if (res != null) {
						let customMessageList = res.data.data;

						customMessageList.forEach(message => {

							const dismissedOn = localStorage.getItem(message.key.toString());
							if (message.key.toString()) {
								const dismissedOnDate = new Date(dismissedOn);
								const today = new Date();
								if(dismissedOn == null) {
									this.customMessage = message;
									this.showPopup = true;
								} else if ((Math.abs(dismissedOnDate.getDate() - today.getDate())) >= message.number_days) {
									localStorage.removeItem(message.key.toString());
									this.customMessage = message;
									this.showPopup = true;
								}
							}
						});
					}
				});
			},

			getFilters : function(options){

				var filters = {
					per_page : this.per_page,
					page : this.current_page,

					sign_up : this.filters.sign_up.id,
					location_id : this.getLocationID(),
					provider_status : this.filters.provider_status.id,
					applicant : this.filters.applicant.id,
					approving_id : this.filters.approving.id,
					supporting_id : this.filters.supporting.id,
					coordinator_id : this.filters.coordinator.id,
					manager_id : this.filters.manager.id,

					search : this.search,

					course_active : this.filters.course_active.id,
					course_status : this.filters.course_status.id,
					duration_method : this.filters.duration_method.id,

					completion_to : this.filters.completion.to,
					completion_from : this.filters.completion.from,

					page_loading : false,

					hiring_date_from : '',
					hiring_date_to : '',

					completion_date_from : '',
					completion_date_to : '',

					approval_date_from : '',
					approval_date_to : '',

					start_date_from : '',
					start_date_to : '',

					due_date_from : '',
					due_date_to : '',
				}

				if(this.filter_applied == "Filtered"){
					if(this.discipline_array.length > 0){
						//this.discipline_array = this.removeAllNoneFromDiscipline(this.discipline_array)
						filters.discipline_ids = this.discipline_array.map(elem =>{ return elem.id
						})
						//logic for Discipline ID ONLY or  AND NOT
						filters.discipline_ids = this.checkDisciplineFilter(filters.discipline_ids,this.discipline_section_only_, this.discipline_array_and_not)
 					}
					if(this.language_array_.length > 0){
						filters.languages = this.language_array_.map(elem =>{
							return elem.id
						})
					}
					if(this.status_array_.length > 0){
						filters.provider_status = this.status_array_.map(elem =>{
							return elem.id
						})
					}
					//you need to do the same for languages
				}else if(this.filter_applied == "None"){

				}else{
					filters.discipline_ids = this.filter_selected.filters.discipline_ids
					//logic for Discipline ID ONLY or  AND NOT
					filters.discipline_ids = this.checkDisciplineFilter(filters.discipline_ids,this.discipline_section_only_, this.discipline_array_and_not)
					filters.languages = this.filter_selected.filters.languages.join();
				}

				filters.search = this.search

				if(options){
					if(options.export){

						if(this.loading_export)
							return;

						filters.export = 1;
						filters.format = options.export.format;

						this.loading_export = true;

					}else{
						this.loading_table_providers = true;
					}
				}else{

					this.loading_table_providers = true;
				}

				if(this.filters.hiring_date != null && (this.filters.hiring_date[0] != null && this.filters.hiring_date[1] != null)){
					filters.hiring_date_from = this.filters.hiring_date[0];
					filters.hiring_date_to = this.filters.hiring_date[1];
				}

				if(this.filters.completion_date != null && (this.filters.completion_date[0] != null && this.filters.completion_date[1] != null)){
					filters.completion_date_from = this.filters.completion_date[0];
					filters.completion_date_to = this.filters.completion_date[1];
				}

				if(this.filters.approval_date != null && (this.filters.approval_date[0] != null && this.filters.approval_date[1] != null)){
					filters.approval_date_from = this.filters.approval_date[0];
					filters.approval_date_to = this.filters.approval_date[1];
				}

				if(this.filters.start_date != null && (this.filters.start_date[0] != null && this.filters.start_date[1] != null)){
					filters.start_date_from = this.filters.start_date[0];
					filters.start_date_to = this.filters.start_date[1];
				}

				if(this.filters.due_date != null && (this.filters.due_date[0] != null && this.filters.due_date[1] != null)){
					filters.due_date_from = this.filters.due_date[0];
					filters.due_date_to = this.filters.due_date[1];
				}

				if(this.filters.course){

					var course_ids = [];

					for(var i in this.filters.course){
						course_ids.push(this.filters.course[i].value);
					}
					// check for no program trigger
					if(course_ids.includes(-1)){
						this.no_program = true
					}else{
						this.no_program = false
					}
					filters.course_id = course_ids.join(',');
				}
				//new agency_Id option
				if(this.user_role === 'csm'){
					filters.organization_id = this.agency.id
				}

				return filters;
			},

			getProviders : function(options){
				if(!this.per_page || this.per_page === undefined)
					return;

				var params = {}

				params.filters = this.getFilters(options);

				this.$store.dispatch('getProvidersCountV2', params).then((res) => {
					this.total_rows = res.data;
				}).catch((error) => {

				});

				this.$store.dispatch('getProvidersV2', params).then((res) => {

					if(res.data.url){
						window.open(res.data.url, '_self');
					}else{

						this.getSignUps(options);
						this.getCompletedCourse(options);

						if(this.filters.course.length == 1){
							this.show_course_options = true;
							this.show_progress_bar = true;
							this.can_bulk_action_providers_in_course = true;
							this.can_bulk_action_providers = false;

						}else if(this.filters.course.length > 1){
							this.show_course_options = false;
							this.can_bulk_action_providers = true;
							this.can_bulk_action_providers_in_course = false;
						}else if(this.filters.course.length == 0){
							this.can_bulk_action_providers = true;
							this.can_bulk_action_providers_in_course = false;
							this.show_course_options = false;
						}
						this.show_progress_bar = true;
						this.providers = res.data.data;
						// check if provider has multiple Disciplines


						this.current_page = res.data.meta.current_page;
						this.per_page = res.data.meta.per_page;
						this.from = res.data.meta.from;
						this.to = res.data.meta.to;
					}

					this.loading_table_providers = false;
					this.loading_export = false;

				}).catch((error) => {
					console.log(error);
					this.loading_table_providers = false;
					this.loading_export = false;
				});


			},

			apply : function(){
				this.getCustomMessages();
				this.filter_applied = 'Filtered';
				this.getProviders({});
			},
			getLocationID: function(){
				if(this.filters.sub_location && this.filters.sub_location.id != -1){
					return this.filters.sub_location.id
				}else{
					return this.filters.location.id
				}
			},
			locationChanged: function(val){
				if(val.children){
					this.filters.location.children.unshift({	id : -1,
						name : 'All' })
					this.filters.sub_location = {	id : -1,
						name : 'All' }
				}else{
					this.filters.sub_location = null
				}
			},
			getLocationFromSubLocation: function(location){
				// here once we get only sub locaiton information
				// we will find the parent location and assign to the location itself

				this.selects.locations.map(elem =>{
					if(elem.id == location.id){
						this.filters.location = location
						this.locationChanged(location)
						return location
					}else if(elem.children){
						elem.children.map(sub_ =>{
							if(sub_.id == location.id){
								this.filters.location = elem
								this.filters.sub_location = location
								return sub_
							}
						})
					}
				})
			},
			getSignUps : function(options){

				this.loading_sign_ups = true;
				var params = {

				}
				params.filters = this.getFilters(options);
				this.$store.dispatch('getProvidersSignUp', params).then((res) => {
					this.sign_ups.active = res.data.percent_active;
					this.sign_ups.not_active = res.data.percent_not_active;
					this.loading_sign_ups = false;

				}).catch((error) => {
					console.log(error);

					this.loading_sign_ups = false;
				});

			},

			getCompletedCourse : function(options){

				this.loading_completed_course = true;

				var params = {

				}

				params.filters = this.getFilters(options);

				this.$store.dispatch('getProviderCompletedCourse', params).then((res) => {

					this.completed_course.completed = res.data.percent_completed;
					this.completed_course.not_completed = res.data.percent_not_completed;
					this.loading_completed_course = false;

				}).catch((error) => {
					console.log(error);
					this.loading_completed_course = false;

				});
			},
			exportProviders : function(){

				this.getProviders({
					export : {
						format : 'csv'
					}
				});
			},

			setPage : function(page){
				this.current_page = page;
				this.getProviders();
				this.clickedUserCheck();
			},
			clickedUserCheck: function(){
				// here we will unclick all users and then check user if is the same and keep the data
				this.unselectAll(false)
				// go to user list and click checked it itt is registered in data
				//this.checked_signups = this.checked_signups.filter(e => {return e.id != item.id })
				setTimeout( () => {
					var checks = this.$refs['bulk-checks'];
					var status_changed = false
					for(var i in checks){
						if((this.checked_signups.filter(elem => elem.id == checks[i].getAttribute('data-id'))).length != 0){
						 	checks[i].checked = true
							status_changed = true
						}
					}
					if(!status_changed){
						this.unselectAll(true)
					}else{
						this.checked_user = 2

					}
				},1000)




			},

			search_ : function(){

				clearTimeout(this.search_timeout);
				this.search_timeout = setTimeout(() => {
					this.getProviders();
				}, 500)
			},
			//retrieve select values
      getStatusOptions: function(){
        let id = '_'
				this.user_role === 'csm' ? id = this.agency.id : id = id
				var params = {
					id : id,
					filters : {
						page_loading : false
					}
				}
        this.$store.dispatch("getStatusInformation", params).then(res => {
          console.log(res)
          if(this.selects.active.length == 1){
            this.selects.active.push(...res.data.data)
          }

				}).catch((error) => {
					console.log(error);
				})

      },
			getDisciplines : function(){
				let id = '_'
				this.user_role === 'csm' ? id = this.agency.id : id = id
				var params = {
					id : id,
					filters : {
						type : 'discipline',
						page_loading : false
					}
				}

				this.$store.dispatch('getTaxonomyValues', params).then((res) => {
					this.selects.disciplines = [];
					this.and_not_disciplines = [];

					this.selects.disciplines = res.data.data;
					this.and_not_disciplines = res.data.data.filter(elem => elem.name != 'None' || elem.name != 'All');
					this.selects.disciplines.unshift({
						id : 0,
						name : 'None'
					});

					this.selects.disciplines.unshift({
						id : -1,
						name : 'All'
					});

				}).catch((error) => {
					console.log(error);
				})
			},
			getLanguages:function(){
				this.selects.languages = []
				var params = {
					filters:{
						available_in_system: 1,
						available_for_users: 1
					}
				};
				this.$store.dispatch("getLanguages", params).then(res => {
					let languages = res.data.data
					for( let i in languages){
						this.selects.languages.push({id:languages[i][0].code_2, name:languages[i][0].name})
					}
					this.selects.languages.unshift({
						id : 0,
						name : 'None'
					});
					this.selects.languages.unshift({
						id : '',
						name : 'All'
					});
				});
			},
			getLocations : function(){
				let id = '_'
				this.user_role === 'csm' ? id = this.agency.id : id = id
				var params = {
					id : id,
					filters : {
						type : 'location',
						page_loading : false
					}
				}

				this.$store.dispatch('getTaxonomyValues', params).then((res) => {

					this.selects.locations = [];

					this.selects.locations = res.data.data;

					this.selects.locations.unshift({
						id : 0,
						name : 'None'
					});

					this.selects.locations.unshift({
						id : -1,
						name : 'All'
					});

				}).catch((error) => {
					console.log(error);
				})
			},

			getSubroles : function(){
				//change params regarding to user role, if csm we give the current agency_id

				if(this.agency != undefined ){
					var params = {
						id : this.agency.id,
						filters : {
							page_loading : false
						}
					}

				}else{
					let org_id = this.$store.getters.getUser.organization_roles[0].id
					var params = {
						id : org_id != null ? org_id : '_',
						filters : {
							page_loading : false
						}
					}
				}


				this.$store.dispatch('getOrganizationSubroles', params).then((res) => {

					for(var i in res.data.data){
						var elem = res.data.data[i];

						var arr = '';

						switch(elem.type){
							case 'coordinator' : arr = 'coordinators'; break;
							case 'manager' : arr = 'managers'; break;
							case 'approve_rn' : arr = 'approving'; break;
							case 'supporting_rn' : arr = 'supporting'; break;
							default :
								break;
						}

						if(arr != ''){
							this.selects[arr].push(elem);
						}
					}

					this.selects.coordinators.unshift({
						id : -1,
						email : 'All'
					});

					this.selects.supporting.unshift({
						id : -1,
						email : 'All'
					});

					this.selects.approving.unshift({
						id : -1,
						email : 'All'
					});

					this.selects.managers.unshift({
						id : -1,
						email : 'All'
					});

				}).catch((error) => {
					console.log(error);
				})
			},

			//my saved filters


			getMyFilters : function(created_parm){

				var params = {
					filters : {
						page_loading : false
					}
				};

				this.$store.dispatch('getUserProviderTableFilters', params).then((res) => {
					this.my_filters = res.data.data;

					var filter_applied = false;
					if(this.my_filters.length == 0){
						this.setDefaultFilter();
					}else{
						for(var i in this.my_filters){
							if(this.my_filters[i].active == 1){

								this.applySelectedFilter(this.my_filters[i]);
								filter_applied = true;

								break;
							}
						}
					}

					if(!filter_applied && created_parm != false){
						this.getProviders();
					}

				}).catch((error) => {
					console.log(error);
				});
			},

			toggleActiveFilter : function(){

			},

			saveFilter : function(){

				if(this.filter_selected.id){

					//how to manage a new filter?
					this.updateFilter();
				}else{
					//if i dont have a filter selected, is a new one, need to ask for the name (trigger popup)

					this.new_filter_name = '';
					this.show_modal_create_filter = true;
					//this.createFilter();

				}
			},

			createFilter : function(){
				//create array of ids of discipline first
				let temp_discipline_ids = this.discipline_array.map(elem =>{ return elem.id })
				this.filters.discipline_ids = this.checkDisciplineFilter(temp_discipline_ids, this.discipline_section_only_, this.discipline_array_and_not)

				// this.filters.discipline_ids =  this.discipline_array.map(elem =>{ return elem.id })
				this.filters.languages =  this.language_array_.map(elem =>{ return elem.id })
				this.filters.provider_status =  this.status_array_.map(elem =>{ return elem.id })

				// may need to do the same for languages
				var params = {
					name : this.new_filter_name,
					filters : this.filters
				};
				//put the dates ok

				if(this.filters.hiring_date[0] != null && this.filters.hiring_date[1] != null){
					// params.filters.hiring_date_from = this.filters.hiring_date[0];
					// params.filters.hiring_date_to = this.filters.hiring_date[1];
					// params.filters.hiring_date = null;
				}

				if(this.filters.completion_date[0] != null && this.filters.completion_date[1] != null){
					// params.filters.completion_date_from = this.filters.completion_date[0];
					// params.filters.completion_date_to = this.filters.completion_date[1];
					// params.filters.completion_date = null;
				}

				if(this.filters.approval_date[0] != null && this.filters.approval_date[1] != null){
					params.filters.approval_date_from = this.filters.approval_date[0];
					params.filters.approval_date_to = this.filters.approval_date[1];
					params.filters.approval_date = null;
				}

				if(this.filters.start_date[0] != null && this.filters.start_date[1] != null){
					params.filters.start_date_from = this.filters.start_date[0];
					params.filters.start_date_to = this.filters.start_date[1];
					params.filters.start_date = null;
				}

				if(this.filters.due_date[0] != null && this.filters.due_date[1] != null){
					params.filters.due_date_from = this.filters.due_date[0];
					params.filters.due_date_to = this.filters.due_date[1];
					params.filters.due_date = null;
				}
				if(this.filters.sub_location && this.filters.sub_location.id != -1){
					this.locationChanged(params.filters.location)
					params.filters.location = this.filters.sub_location
				}
				params.filters.page_loading = false;
				this.show_modal_create_filter = false;
				//this.closeFilters();

				this.$store.dispatch('createUserProviderTableFilters', params).then((res) => {
					this.getMyFilters();
				}).catch((error) => {
					console.log(error);
				})
			},

			updateFilter : function(){
				var params = {
					id : this.filter_selected.id,
					name : this.filter_selected.name,
					filters : this.filters
				}

				params.filters.page_loading = false;

				this.$store.dispatch('updateUserProviderTableFilters', params).then((res) => {
				}).catch((error) => {
					console.log(error);
				})
			},

			showModalDeleteFilter : function(filter){
				this.filter_to_delete = filter;

				this.show_modal_delete_filter = true;
			},

			deleteFilter : function(){
				var params  = {
					id : this.filter_to_delete.id,
					filters : {
						page_loading : false
					}
				}

				this.show_modal_delete_filter = false;
				this.closeFilters();

				this.$store.dispatch('deleteUserProviderTableFilter', params).then((res) => {
					this.filter_to_delete = null;


					this.getMyFilters();
				}).catch((error) => {

				});
			},

			closeMyFilters : function(){
				this.$root.$emit('bv::hide::popover', 'my-saved-filters-button');
			},

			applySelectedFilter : function(my_filter){

				this.filters = JSON.parse(JSON.stringify(my_filter.filters));
				this.filter_selected = JSON.parse(JSON.stringify(my_filter));
				this.old_filter_name = my_filter.name;

				//Use selected filter valus and inject into array of dicipline and languges
				this.getLocationFromSubLocation(my_filter.filters.location)
				if(this.filters.discipline_ids.length > 0){
					this.discipline_array = []
					// this.getSavedFiltersDropdown(this.discipline_array, this.filters.discipline_ids, 'disciplines');
					//Make changes for ONLY Discipline dropdown
					 if(this.filters.discipline_ids[0].toString().includes('!')){
						this.filters.discipline_ids[0] = Number(this.filters.discipline_ids[0].substring(1));
							 this.discipline_section_only_ = {
							 id:1, name: "Only"
						 }

					 }else{
						this.discipline_section_only_ = {
							 id:0, name: "Any"
						 }

					 }
					for(let i in this.filters.discipline_ids){
						this.selects.disciplines.filter(e =>{
							if(this.filters.discipline_ids[i] < 0){
								if(e.id == Math.abs(this.filters.discipline_ids[i])){
									this.discipline_array_and_not.push({id:e.id, name: e.name})
								}
							}else{
								if(e.id == this.filters.discipline_ids[i]){
									this.discipline_array.push({id:e.id, name: e.name})
								}

							}
						})
					}
				}
				///Language existing filter
				if(this.filters.languages.length > 0){
					this.language_array_ = []
					for(let i in this.filters.languages){
						this.selects.languages.filter(e =>{
							if(e.id == this.filters.languages[i]){
        					  this.language_array_.push({ name: e.name, id: e.id })
							}
						})
					}
          			//this.language_array_ = this.language_array;
          			//  this.getSavedFiltersDropdown(this.language_array_, this.filters.languages, 'languages');

				}
				if(this.filters.provider_status.length>0){
					this.status_array_ = []
					for(let i in this.filters.provider_status){
						this.selects.active.filter(e =>{
							if(e.id == this.filters.provider_status[i]){
        					  this.status_array_.push({ name: e.name, id: e.id })
							}
						})
					}
				}
				//note here hiriing date
				console.log(this.filter_selected.filters.hiring_date)
				this.filters.hiring_date = this.filter_selected.filters.hiring_date
				// this.filters.hiring_date = [
				// 	this.filters.hiring_date_from, this.filters.hiring_date_to
				// ];

				this.filters.completion_date = this.filter_selected.filters.completion_date
				// this.filters.completion_date = [
				// 	this.filters.completion_date_from, this.filters.completion_date_to
				// ];

				this.filters.approval_date = [
					this.filters.approval_date_from, this.filters.approval_date_to
				];

				this.filters.start_date = [
					this.filters.start_date_to, this.filters.start_date_from
				];

				this.filters.due_date = [
					this.filters.due_date_from, this.filters.due_date_to
				];

				this.filter_selected_initial_value = JSON.parse(JSON.stringify(this.filters));

				this.closeFilters();

				this.filter_applied = 'Filtered';
				this.getProviders();
			},

			toggleActiveFilter : function(my_filter){
				var params = {
					id : my_filter.id
				}

				this.$store.dispatch('toggleActiveUserProviderFilter', params).then((res) => {
					this.getMyFilters();
				}).catch((error) => {

				});
			},
			setDefaultFilter : function(){
				this.filter_selected = this.filters;
				this.filter_selected_initial_value = {};
				this.filter_selected_initial_value = JSON.parse(JSON.stringify(this.filter_selected));
			},
			getCourses : function(){
				//If agency is selected, we need to update the program SELECTION
				if(this.agency){
					var params = {
						id : this.agency.id,
						filters : {
							// per_page : 500,
							to_select : true,
							page_loading : false,
							published:true
						}
					}
					this.$store.dispatch('getOrganizationCourses', params).then((response) => {

						this.selects.courses = [];
						this.selects.courses = response.data.data;
						let no_program_all_user = {label: "No Program", value:-1}
						this.selects.courses.push(no_program_all_user);

					}).catch((error) => {
						console.log(error);
					})

				}else{
					var params = {
						filters : {
							to_select : true,
							in_organization : '_',
							only_organization : true,
							page_loading : false
						}
					}
					this.$store.dispatch('getCourses', params).then((response) => {

						this.selects.courses = [];

						this.selects.courses = response.data.data;
						let no_program_all_user = {label: "No Program", value:-1}
						this.selects.courses.push(no_program_all_user);



					}).catch((error) => {
						console.log(error);
					})
				}
				//lets add no program all users option
					let no_program_all_user = {label: "No Program", value:-1}
					this.selects.courses.push(no_program_all_user);

			},
			getAddToProgramCourses: function(){
				this.getInClassPrograms();
				let api_call_courses = 'getOrganizationCourses'
				var params = {
					filters : {
						to_select : true,
						only_organization : true,
						published : true,
						page_loading : false
					}
				}
				if(this.agency){
					params.id = this.agency.id
				}else{
					api_call_courses = 'getCourses'
					params.filters.in_organization = '_'
				}
				//add  session or regular program filter
				params.filters.in_class = (this.add_program_type == 'online') ?  0 : 1

				this.$store.dispatch(api_call_courses, params).then((response) => {
					this.add_to_program_courses = response.data.data

				}).catch((error) => {
					console.log(error);
				})


			},
			getInClassPrograms: function(){
				let api_call_courses = 'getOrganizationCourses'
				var params = {
					filters : {
						to_select : true,
						only_organization : true,
						page_loading : false,
						published : true,
						in_class: 1
					}
				}
				if(this.agency){
					params.id = this.agency.id
				}else{
					api_call_courses = 'getCourses'
					params.filters.in_organization = '_'
				}
				this.$store.dispatch(api_call_courses, params).then((response) => {
					this.add_to_program_courses_in_class = response.data.data

				}).catch((error) => {
					console.log(error);
				})
			},

			closeFilters : function(){
				this.show_filters = false;
				this.show_my_saved_filters = false;
			},

			openFilters : function(){

				this.show_filters = !this.show_filters;
				this.show_my_saved_filters = false;
			},

			showMySavedFilters : function(top, right){

				this.my_filters_top = top;
				this.my_filters_right = right;

				this.show_my_saved_filters = !this.show_my_saved_filters
			},

			showSelectAll : function(){

				this.checked_signups = []
				var checks = this.$refs['bulk-checks'];

				//we have the previous value, so when we receive a false is because the checkbox was marked
				if(!this.checkbox_bulk){

					for(var i in checks){
						checks[i].checked = true;
					}

					this.show_select_all = true;
					this.n_bulk_selected = checks.length;
					this.checked_user = checks.length
				}else{
					this.show_select_all = false;
					this.checked_user = 0;
					this.select_all = false
					//we set all to false
					for(var i in checks){
						checks[i].checked = false;
					}
				}
				this.checked_user_refs = checks
			},

			selectAll : function(){
				this.select_all = true;
				this.checked_user = 2
			},

			unselectAll : function(clear_checked){
				this.select_all = false;
				this.show_select_all = false;
				this.checkbox_bulk = false;
				this.checked_user = 0;
				if(clear_checked == true){
					this.checked_signups = [];

				}
				var checks = this.$refs['bulk-checks'];
				for(var i in checks){
					checks[i].checked = false;
				}
			},
		    Password_Reset_SignUp_Selection: function(){
			   // before resetting bulk sms or email password-action
			   // will uncheck users that are not signed_up yet.
			   var checks = this.$refs['bulk-checks'];
			   for(var i in checks){
				   if(checks[i].checked === true  && checks[i].getAttribute('data-sign_up') != 1){
					   checks[i].checked = false
				   }
			   }

		   },
			toggleProvider : function(provider){
				var method = '';

				if(provider.active){
					//deactivate provider
					method = 'deleteProviderFromOrganization';
				}else{
					//activate provider
					method = 'addProviderToOrganization';
				}

				if(this.user_role === 'csm'){
					let organization_id = this.agency_info
					var params = {
						organization_id : organization_id,
						provider_id : provider.id,
						filters : {
							page_loading : false
						}
					}

				}else{
					var params = {
						organization_id : '_',
						provider_id : provider.id,
						filters : {
							page_loading : false
						}
					}
				}

				this.$store.dispatch(method, params).then((res) => {
					provider.active = !provider.active;
				}).catch((error) => {
					console.log(error);
				});
			},

			toggleProviderCourse : function(provider){
				var method = '';
				if(provider.course_active){
					//deactivate provider
					method = 'deactiveProviderFromProgram';
					// method = 'deleteProviderFromCourse';
				}else{
					//activate provider
					method = 'addProviderToCourse';
				}
				let organization_id = '_'
				if(this.user_role === 'csm'){
					if(this.agency_info != ''){
						organization_id = this.agency_info
					}else{
						organization_id = this.$route.params.agency_id
					}
				}
				var params = {
					id : provider.course_id,
					// use_v2: provider.timing_method ? true : false,
					provider_id : provider.id,
					organization_id : organization_id,
					//start_date: provider.starting_date,
					//timing_method: provider.timing_method,
				}

				this.$store.dispatch(method, params).then((res) => {
					provider.course_active = !provider.course_active;
				}).catch((error) => {
					console.log(error);
				});
			},

			resetBulk : function(){
				this.bullk_selection = [];
				this.select_all = false;
				var checks = this.$refs['bulk-checks'];

				for(var i in checks){
					checks[i].checked = false;
				}

				this.checkbox_bulk = false;
				this.show_select_all = false;
			},

			completionSliderChange : function(value, index){
				this.filters.completion.from = value[0];
				this.filters.completion.to = value[1];
			},
			//bulk actions
			openBulkModal : function(name,provider){
				// reset_password_plain get it's data from tbale v-for
				if(provider != null || provider != undefined){
					this.bulk_selection = [];
					this.bulk_selection.push({
						first_name : provider.first_name,
						last_name : provider.last_name,
						id :provider.id
					})
				}else if(name === "sign_up_sso"){
					this.bulk_selection = [];
					this.bulk_selection.push({
						first_name : provider.first_name,
						last_name : provider.last_name,
						id :provider.id,
						email : provider.email,
						sign_up : provider.sign_up
					})
				}
				else{

					this.bulk_selection = [];
					//new condition
					// if filtered and select_all and total_rows  > 50
					// we make an api call to get provider ids
					if((this.search != '' && this.show_select_all) || this.total_rows >49 &&  this.filter_applied == 'Filtered' && this.select_all){
						//now lets get provider ids and send it to sendSMS Modal
						this.bulk_selection  = []
						var params = {}
						params.filters = this.getFilters(params);
						params.filters.only_ids = 1
						params.filters.per_page = this.total_rows

						this.$store.dispatch('getProvidersV2', params).then((res) => {
							this.bulk_selection = res.data
						})


					}
					else if(!this.select_all || this.filter_applied == 'Filtered'){
						// here I will check for sms or email reset and then execute sign_up functionality
						if(name ==='reset_password_email' || name == 'reset_password_text'){
							//update checks
							this.Password_Reset_SignUp_Selection();
						}
						var checks = this.$refs['bulk-checks'];
					// here we add id attribute as well for reset password parameters
						for(var i in checks){
							if(checks[i].checked){
								this.bulk_selection.push({
									first_name : checks[i].getAttribute('data-first-name'),
									last_name : checks[i].getAttribute('data-last-name'),
									status_str : checks[i].getAttribute('data-status-str'),
									id : checks[i].dataset.id
								});
							}
						}
					}else{
						var checks = this.$refs['bulk-checks'];

					}
				}

				this.bulk_selection.sort(function(a, b){

					if(a.last_name && b.last_name){
						var x = a.last_name.toLowerCase();
					    var y = b.last_name.toLowerCase();
					    return x < y ? -1 : x > y ? 1 : 0;
					}else{
						return 0;
					}

				});
				this.bulk_modals['show_' + name] = true;

			},
			closeBulkModal: function(name){
				this.bulk_modals['show_' + name] = false;
			},
			getParamsForBulkOrganizationProvider : function(){
				var params = {
					organization_provider_ids : [],
					filters : {
						page_loading : false
					}
				}

				params.filters = this.getFilters({});

				if(this.select_all){
					params.filters.organization_provider_ids = '0';
				}else{
					var checks = this.$refs['bulk-checks'];
					var organization_provider_ids = [];

					for(var i in checks){
						if(checks[i].checked){
							organization_provider_ids.push(checks[i].getAttribute('data-organization-provider-id'));
						}
					}
					params.filters.organization_provider_ids = organization_provider_ids.join('_');
				}

				return params;
			},

			activateProviders : function(){
				var params = this.getParamsForBulkOrganizationProvider();
        params.to_status_id = 1
				this.$store.dispatch('BULK_ORGANIZATION_PROVIDER_CHANGE_STATUS', params).then((res) => {
					this.getProviders();
					this.clickedUserCheck()
					this.password_index++;
				}).catch((error) => {
					console.log(error);
					this.getProviders();
				})
			},
			terminateProviders : function(){
				var params = this.getParamsForBulkOrganizationProvider();
        params.to_status_id = 3
				this.$store.dispatch('BULK_ORGANIZATION_PROVIDER_CHANGE_STATUS', params).then((res) => {
					this.getProviders();
					this.clickedUserCheck()
					this.password_index++;
				}).catch((error) => {
					console.log(error);
					this.getProviders();
				})
			},

			deactivateProviders : function(){
				var params = this.getParamsForBulkOrganizationProvider();
        params.to_status_id = 2

				this.$store.dispatch('BULK_ORGANIZATION_PROVIDER_CHANGE_STATUS', params).then((res) => {
					this.getProviders();
					this.clickedUserCheck()
					this.password_index++;
				}).catch((error) => {
					console.log(error);
					this.getProviders();
				})
			},

			removeProviders: function(){
				var params = this.getParamsForBulkOrganizationProvider();

				this.$store.dispatch('BULK_ORGANIZATION_PROVIDER_DELETE', params).then((res) => {
					this.getProviders();
					this.clickedUserCheck()
					this.password_index++;
				}).catch((error) => {
					console.log(error);
					this.getProviders();
				})
			},
			fetchSessionData: function(session_data){
				if(session_data.id){
					this.session_data_add_program = session_data.id
				}
			},
			addProvidersToProgramWithSession(id){
				var params = this.getParamsForBulkOrganizationProvider();
				params.filters.session_id = id
				this.addProvidersToProgram(params)
			},
			addProvidersToCourse : function($event){
				$event.preventDefault();
				if(this.session_is_new && this.add_program_type == 'in-class'){
					EventBus.$emit('checkSessionStatus')
					return
				}
				else if(this.add_program_type == 'in-class'){
					EventBus.$emit('checkSessionStatus')
					if(this.session_data_add_program){
						var params = this.getParamsForBulkOrganizationProvider();
						params.filters.session_id = this.session_data_add_program
						this.addProvidersToProgram(params)
					}
				}else{
					if(this.validateAddProvidersToCourse()){
						var params = this.getParamsForBulkOrganizationProvider();

						params.course_id_ = this.add_to_program.course.map(elem => elem.value);
						
						params.timing_method = this.add_to_program.timing_method.value;
						params.starting_date_method = this.add_to_program.starting_date_method.value;

						if(params.starting_date_method == 2){
							params.starting_date = this.add_to_program.starting_date.toISOString().split('T')[0];
						}

						if (params.starting_date_method == 3 || params.starting_date_method == 4) {
							params.starting_date_plus_x_days = this.add_to_program.starting_date_plus_x_days;
						}

						if(params.timing_method == 5){
							params.duration_days_from_start_date = this.add_to_program.duration_days_from_start_date
						}
						if(params.timing_method == 4){
							params.due_date = this.add_to_program.duration_date.split('T')[0];
						}else{
							delete params.due_date
						}
						// manuallly change the per_page
						delete params.filters.per_page
						this.addProvidersToProgram(params)
					}else{
						//dont close the modal
						event.preventDefault();
					}

				}

			},
			addProvidersToProgram(params){
					this.loading_table_providers = false;
					var toast = this.$snotify.info('Adding employees to program...', {
						timeout : 0
					});
					this.$store.dispatch('BULK_ORGANIZATION_PROVIDER_ADD_TO_PROGRAM', params).then((res) => {
						this.session_data_add_program = null
						this.clickedUserCheck();
						this.cleanSessionForm()
						this.bulk_modals.show_add_to_program = false

						setTimeout( () => {
							this.$snotify.remove(toast.id);
						}, 500);

						this.add_to_program = {
							course_id : null,
							starting_date : null,
							starting_date_method_: null,
							timing_method : null,
						}
					}).catch((error) => {
						console.log(error);
					})
			},

			validateAddProvidersToCourse : function(){

				this.show_add_to_program_errors = false;

				//var is_valid = (this.add_to_program.course != null && this.add_to_program.starting_date_method_ != null);
				var is_valid = (this.add_to_program.course != null && this.add_to_program.timing_method != null);
				console.log('Program: ' + JSON.stringify(this.add_to_program.course));
				console.log('Start Date: ' + JSON.stringify(this.add_to_program.starting_date));
				console.log('Duration: ' + JSON.stringify(this.add_to_program.timing_method));

				if(!is_valid){
					this.show_add_to_program_errors = true;
				}

				return is_valid;
			},

			getParamsForBulkOrganizationProviderCourse : function(){

				var params = {
					// organization_provider_ids : [],
					filters : {
						page_loading : false
					}
				}

				params.filters = this.getFilters({});

				if(this.select_all){
					params.filters.organization_provider_ids = 'all';
				}else{
					var checks = this.$refs['bulk-checks'];
					var organization_provider_ids = [];
					var organization_provider_course_ids = [];

					for(var i in checks){
						if(checks[i].checked){
							organization_provider_ids.push(checks[i].getAttribute('data-organization-provider-id'));
							organization_provider_course_ids.push(checks[i].getAttribute('data-organization-provider-course-id'));
						}
					}

					params.filters.organization_provider_ids = organization_provider_ids.join('_');
					params.filters.organization_provider_course_ids = organization_provider_course_ids.join('_');
				}

				return params;
			},

			activateProvidersInCourse : function(){

				var params = this.getParamsForBulkOrganizationProviderCourse();

				this.$store.dispatch('BULK_ORGANIZATION_PROVIDER_COURSE_ACTIVATE', params).then((res) => {
					this.getProviders();
					//if deactive providers filtered
					if(this.filter_selected.active.id == 0){
						this.unselectAll(true);
					}
				}).catch((error) => {
					this.getProviders();
					this.resetBulk();
					this.unselectAll(true);
					console.log(error);
				})
			},

			deactivateProvidersInCourse : function(){

				var params = this.getParamsForBulkOrganizationProviderCourse();

				this.$store.dispatch('BULK_ORGANIZATION_PROVIDER_COURSE_DEACTIVATE', params).then((res) => {
					this.getProviders();
					if(this.filter_selected.active.id == 1){
						this.unselectAll(true);
					}
					//this.resetBulk();
				}).catch((error) => {
					this.getProviders();
					this.resetBulk();
					this.unselectAll(true);
					console.log(error);
				})
			},

			editDueDateProvidersInCourse : function(){

				var params = this.getParamsForBulkOrganizationProviderCourse();

				params.due_date = this.edit_due_date.split('T')[0];
				params.notify = this.notify_edit_due_date;


				this.$store.dispatch('BULK_ORGANIZATION_PROVIDER_COURSE_DUE_DATE', params).then((res) => {
					this.getProviders();
					this.resetBulk();

					this.edit_due_date = '';
					this.show_error_due_date = false;
				}).catch((error) => {
					console.log(error);
				})
			},

			editStartDateProvidersInCourse : function(){

				var params = this.getParamsForBulkOrganizationProviderCourse();

				params.starting_date = this.edit_start_date.split('T')[0];
				params.notify = this.notify_edit_start_date;


				this.$store.dispatch('BULK_ORGANIZATION_PROVIDER_COURSE_START_DATE', params).then((res) => {
					this.getProviders();
					this.resetBulk();

					this.edit_start_date = '';
					this.show_error_start_date = false;
				}).catch((error) => {
					console.log(error);
				})
			},

			approveProvidersInCourse : function(){

				var params = this.getParamsForBulkOrganizationProviderCourse();

				this.$store.dispatch('BULK_ORGANIZATION_PROVIDER_COURSE_APPROVE', params).then((res) => {
					this.getProviders();
					this.resetBulk();

					this.edit_due_date = '';
					this.show_error_due_date = false;
				}).catch((error) => {
					console.log(error);
				})
			},

			sendMessageInCourse : function(){
				var params = this.getParamsForBulkOrganizationProviderCourse();
				params.text = this.message_text;

				this.loading_table_providers = false;

				var toast = this.$snotify.info('Sending message...', {
					timeout : 0
				});

				this.$store.dispatch('BULK_ORGANIZATION_PROVIDER_COURSE_MESSAGE', params).then((res) => {

					this.resetBulk();
					this.message_text = '';

					setTimeout( () => {
						this.$snotify.remove(toast.id);
					}, 500);

				}).catch((error) => {
					console.log(error);
				})
			},
			deleteProvider: function(provider){
				let user_id = provider[0].id
				var params = {
					id: user_id
				}
				var toast = this.$snotify.info('Deleting User...', {
					timeout : 0
				});
				this.$store.dispatch('deleteProvider', params).then((res) => {
					this.getProviders();
					this.resetBulk();
					setTimeout( () => {
						this.$snotify.remove(toast.id);
					}, 500);
				}).catch((error) => {
					console.log(error);
				})

			},

			downloadCertificates : function(){

				var params = this.getParamsForBulkOrganizationProviderCourse();


				var toast = this.$snotify.info('Downloading certificates...', {
					timeout : 0
				});

				this.loading_table_providers = false;

				this.$store.dispatch('BULK_ORGANIZATION_PROVIDER_COURSE_CERTIFICATE', params).then((res) => {
					if(res.data.url){
						window.open(res.data.url, '_self');
					}

					setTimeout( () => {
						this.$snotify.remove(toast.id);
					}, 500);
				}).catch((error) => {
					console.log(error);
				})
			},

			sendCertificates : function(){

				var params = this.getParamsForBulkOrganizationProviderCourse();

				var toast = this.$snotify.info('Sending certificates...', {
					timeout : 0
				});

				this.loading_table_providers = false;
				this.$store.dispatch('BULK_ORGANIZATION_PROVIDER_COURSE_CERTIFICATE_SEND', params).then((res) => {

					setTimeout( () => {
						this.$snotify.remove(toast.id);
					}, 500);
				}).catch((error) => {
					console.log(error);
				})
			},

			checkboxClicked : function(item){
				//show_select_all block
				if(this.select_all){
				   this.select_all = !this.select_all
				}
				if(this.show_select_all){
					this.checked_signups = []
					let user_list = this.checked_user_refs
					for(let i in user_list){
						if(user_list[i].checked){
							this.checked_signups.push({status:user_list[i].getAttribute('data-sign_up'), id:user_list[i].getAttribute('data-id') })
						}
					}
					this.show_select_all = false
					this.checkbox_bulk = false
					if(this.checked_signups.length >=1){
						this.checked_user = 2
					}else{
						this.checked_user = this.checked_signups.length
					}
					return
				}


				if(this.checkbox_bulk){
					this.checked_user = 2
					return
				}else{
					if(this.checked_signups.length == 0){
						this.checked_signups.push( {status:item.sign_up, id:item.id })
						this.checked_user = 1
						return
					}
					else if((this.checked_signups.filter(o => o.id == item.id)) == 0){
						this.checked_signups.push( {status:item.sign_up, id:item.id })
					}else{
						this.checked_signups = this.checked_signups.filter(e => {return e.id != item.id })

					}
					//set checked user number
					if(this.checked_signups.length >=1){
						this.checked_user = 2
					}else{
						this.checked_user = this.checked_signups.length
					}

				}
			},
			loginSSO: function(item){
			 let agency_id = this.agency_info
			 let user_id = item.id
				var params = {
						agency_id : agency_id,
						user_id : user_id
				}
				this.$store.dispatch('loginAsProviderSSO',params).then((res)=>{
					if(res.data.url){
						window.open(res.data.url, '_blank');
					}

				}).catch((error) => {
					console.log(error);
				})
			},
			updateNewProviderComponent: function(){
				this.componentKey += 1;
			},
			closeLoadingTableIcon: function(){
				this.loading_table_providers = false
			},
			checkDisciplineFilter: function(discipline_filter, discipline_only,	discipline_array_and_not){
		 		if (discipline_only.id == 1) {
					//add ! to the beginning
					if (!discipline_filter[0].toString().includes("!")) {
						if(discipline_filter[0] == -1 || discipline_filter[0] == 0){
						}else{
							discipline_filter[0] = "!" + discipline_filter[0].toString();
						}
					return discipline_filter;
					} else {
					return discipline_filter;
					}
				} else {
					// we need to concat the AND NOT array values of the discipline dropdown
				// we will insert negative values of that array
				discipline_array_and_not = discipline_array_and_not.map(elem => {
				return elem.id * -1;
				});
				// console.log(discipline_array_and_not);
				return discipline_filter.concat(discipline_array_and_not);
			}
		},
		removeAllNoneFromDiscipline(discipline_list){
			let temp_all_none = [
				{name:'All', id:-1},
				{name:'None', id:0},
			]
			discipline_list = discipline_list.filter(elem => elem.name != 'All' || elem.name != 'None')
			//iscipline_list.filter(elem => elem.name != 'None')
			return discipline_list
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/shared/ProviderListComponent.vue